<footer>
  <div class="footer-body">
    <div class="container">
      <div class="row">
        <div class="col-md-4">
          <h3>
            BİZE ULAŞIN
          </h3>
          <ul>
            <li>
              <i class="fa fa-map-marker"></i>
              <span>
                Koşuyolu Mh. Halili Sk. No:9/2 34718
                Kadıköy / İstanbul
              </span>
            </li>
            <li>
              <i class="fa fa-phone"></i>
              <a href="javascript:void(0)" tel="02169691191">
                +90 (216) 969 11 91 (pbx)
              </a>
            </li>
            <li>
              <i class="fa fa-print"></i>
              <a href="javascript:void(0)" tel="02169691197">
                +90 (216) 969 11 97
              </a>
            </li>
            <li>
              <i class="fa fa-whatsapp"></i>
              <a href="https://api.whatsapp.com/send?phone=905384913362" target="_blank">
                +90 (538) 491 33 62
              </a>
            </li>
            <li>
              <i class="fa fa-envelope-o"></i>
              <a href="mailto:info@cardata.com.tr">
                info@cardata.com.tr
              </a>
            </li>
          </ul>
        </div>
        <div class="col-md-4">
          <h3>
            <a [routerLink]="['/products']">ÜRÜNLERİMİZ</a>
          </h3>
          <ul class="footer-link">
            <li>
              <a [routerLink]="['/used_car_pricing']"><i class="fa fa-angle-double-right"></i>2.El Araç
                Fiyatlandırma Uygulaması</a>
            </li>
            <li>
              <a href="https://hemensat.cardata.com.tr" target="_blank"><i
                  class="fa fa-angle-double-right"></i>Aracınızı Değerinde Satın Alıyoruz</a>
            </li>
            <li>
              <a href="/default#vehicle-data"><i class="fa fa-angle-double-right"></i>Araç Katalog
                Verileri</a>
            </li>
            <li>
              <a [routerLink]="['/instant-cash-offer']"><i class="fa fa-angle-double-right"></i>2.El Araç Tedariği
                Sağlama
                Uygulaması</a>
            </li>
            <li>
              <a href="/default#new-car"><i class="fa fa-angle-double-right"></i>0 Km Araç Fiyatı Sorgulama</a>
            </li>
            <li>
              <a href="/default#new-car"><i class="fa fa-angle-double-right"></i>Araç
                Karşılaştırma</a>
            </li>
          </ul>
        </div>
        <div class="col-md-4">
          <h3>
            KURUMSAL
          </h3>
          <ul class="footer-link">
            <li>
              <a [routerLink]="['/about-us']"><i class="fa fa-angle-double-right"></i>Hakkımızda</a>
            </li>
            <li>
              <a [routerLink]="['/bayimiz-olun']"><i class="fa fa-angle-double-right"></i>Bayimiz Olun</a>
            </li>
            <li>
              <a [routerLink]="['/contact']"><i class="fa fa-angle-double-right"></i>İletişim</a>
            </li>
            <li>
              <a href="javascript:void(0)" class="privacy_policy"><i class="fa fa-angle-double-right"></i>Gizlilik
                Politikası</a>
            </li>
            <li>
              <a href="javascript:void(0)" class="terms_of_use"><i class="fa fa-angle-double-right"></i>Kullanım
                Koşulları</a>
            </li>
            <li>
              <a href="javascript:void(0)" class="protection_of_personal_data"><i
                  class="fa fa-angle-double-right"></i>Kişisel
                Verilerin Korunması</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
  <div class="footer-copy-row">
    <div class="container">
      <div class="row">
        <div class="col-md-12">
          <p class="lh-20">
            ©Copyright 2012-{{cYear}} CARDATA® <br>
            CARDATA®, CDI Otomotiv Bilgi Hizmetleri A.Ş.’ye ait bir otomotiv markasıdır. CARDATA®nın her hakkı
            saklıdır ve koruma altındadır.
          </p>
        </div>
      </div>
    </div>
  </div>
</footer>
<!-- Aggrement modal -->
<div id="privacy_policy_modal" class="modal-wrapper" style="display: none">
  <h3>Gizlilik Politikamız</h3>
  <div class="modal-body">
    <p class=MsoNormal align=center style='text-align:center'><span
        style='font-size:9.5pt;line-height:115%;font-family:"Times New Roman",serif'>Car
        Data <span class=SpellE>Internatıonal</span></span><span style='font-size:7.0pt;
      line-height:115%;font-family:"Arial",sans-serif;color:#2A3238;background:white'>-</span><span
        style='font-size:9.5pt;line-height:115%;font-family:"Times New Roman",serif'>CDI
        Otomotiv Bilgi Hizmetleri A.Ş.’ne (kısaca CDI olarak anılacaktır) ait Web
        Sayfası, Mobil Uygulama ve Modülleri; bunlar üzerinden elde edilen bilgiler ile
        bireysel ve kurumsal üyelerinin/abonmanların/kullanıcıların verdikleri bilgileri
        güvenlik ve gizlilik prensipleri doğrultusunda korunduğu interaktif platformlardır.</span></p>

    <p class=MsoNormal align=center style='text-align:center'><span
        style='font-size:9.5pt;line-height:115%;font-family:"Times New Roman",serif'>Gizliliğin
        sağlanması ve sürdürülebilirliği için, sözleşme ve kullanım koşullarında
        belirlenen istisnalar dışında gizli bilginin tamamının veya herhangi bir
        kısmının alenileşmesini ve yetkisiz kullanımını önlemek için gerekli tüm
        tedbirleri almakta ve gerekli özeni göstermekteyiz. Bu hususta gerekli özeni
        sizinde göstereceğinize inanıyoruz. Bu nedenle, abone/üye/kullanıcı/ziyaretçi,
        uygun ve gerekli güvenlik önlemleri alınmış araçlarla sisteme ulaşmalı, virüs
        ve sair zararlı yazılımlara karşı gerekli tüm tedbirler almış olmalıdır. Ayrıca
        kullanıcı adı, giriş kodu, şifre vb. gibi CDI tarafından size özel verilmiş bilgilerinizi
        üçüncü kişilerle paylaşmamalısınız. Aksi halde <span class=SpellE>CDI’ın</span>
        hiçbir sorumluluğu bulunmamaktadır.</span></p>

    <p class=MsoNormal align=center style='text-align:center'><span
        style='font-size:9.5pt;line-height:115%;font-family:"Times New Roman",serif'>Kişisel
        bilgileriniz, bu bilgilerin toplanması ile ilgili dokümanlarımızda açıklanan
        amaçlar (Kullanım Koşulları, ilgili <span class=SpellE>Sözleşmeve</span>
        Kişisel Verilerin Korunması Hakkında Aydınlatma Metni) ve sistem üzerinden
        vereceğiniz onay dışında, 3. kişilerle paylaşılmamakta ve kullanılmamaktadır.</span></p>

    <p class=MsoNormal align=center style='text-align:center'><span
        style='font-size:9.5pt;line-height:115%;font-family:"Times New Roman",serif'>Üyelik,
        e-bülten abonmanlığı, web sitesi veya mobil uygulamaların kullanılabilmesi için
        istenen ve sizin tarafınızdan <span class=GramE>verilen</span> bilgiler, kişisel
        veriler ve iletişim bilgileri (ad, <span class=SpellE>soyad</span>, telefon
        numarası, adres, e-posta adresi, araca ait bilgiler gibi) hizmetten
        faydalanmanız için onay kodu yollanması, üye veya abonman kayıtlarının
        oluşturulması, sizinle temas kurulması veya doğrudan pazarlama yapılması
        amacıyla kullanabilmektedir. Fiyat sorgulama uygulamamızda (Aracını Hemen
        Değerinde Sat) yapacağınız sorgulamalara ait raporlamalar ve vereceğiniz iletişim
        bilgileriniz talebiniz olmaksızın başkalarıyla paylaşılmayacaktır. Sadece
        sizinle iletişime geçilmesini istemeniz halinde/koşuluyla, vermiş olduğunuz iletişim
        bilgileriniz ve uygulamadaki sorgulamaya ait raporlamanız sizinle iletişime
        geçecek muhtemel araç alıcısı olan üyeler ile paylaşılacaktır. Bu talep/istek/onayınızı
        web sayfası veya mobil uygulamalar üzerindeki ilgili onay/talep kutucuklarını
        işaretleyerek vermektesiniz. İsteğiniz üzerine iletişim bilginizi ve araca
        ilişkin raporlamanızın aktarılması ile <span class=SpellE>CDI’ın</span>
        fonksiyonu sona ermekte olup, bu aşamadan sonrasına ilişkin <span class=SpellE>CDI’ın</span>,
        taraflara ve aralarındaki işlemlere yönelik olarak herhangi bir kontrol ve
        denetim mekanizması, kişi ile iletişime geçilip geçilmemesi dahil herhangi bir taahhüdü
        veya sorumluluğu bulunmamaktadır. Bu nedenle Hemen Sat uygulamasını/araç değeri
        sorgulamasını kullanan kişi, elektronik ortamda kendisi ile iletişime geçilmesi
        talebinde bulunmasından sonra <span class=SpellE>CDI’ın</span>, kendisi ile
        muhtemel araç alıcısı arasında gelişecek sürecin, ilişkinin ve muhtemel akdin
        herhangi bir şekilde tarafı veya aracısı olmadığını ve aralarındaki gerçekleşecek
        sözleşme kapsamında tarafların yükümlülüklerini yerine getirmeleri ile ilgili <span class=SpellE>CDI’ın</span>
        herhangi bir sorumluluğu ve taahhüdü bulunmadığını
        kabul ve beyan ederler.</span></p>

    <p class=MsoNormal align=center style='text-align:center'><span
        style='font-size:9.5pt;line-height:115%;font-family:"Times New Roman",serif'>Web
        sayfamızda yahut uygulamalarımızda talep edilen bilgiler, sizin tarafından
        sağlanan bilgiler, web sitesi yahut uygulamalar üzerinden yapılan işlemlerle
        ilgili bilgiler, biz ve işbirliği içinde olduğumuz kişiler tarafından
        kullanıcının kimliği ifşa edilmeden çeşitli istatistiksel değerlendirmeler,
        veri tabanı oluşturma ve pazar araştırmalarında anonimleştirilerek kullanılabilecektir.</span></p>

    <p class=MsoNormal align=center style='text-align:center'><span
        style='font-size:9.5pt;line-height:115%;font-family:"Times New Roman",serif'>CDI,
        başka sitelere link verebilir veya kendi sitesinde linklere yer verebilir. Bu
        halde link vasıtasıyla erişilen sitelerin gizlilik uygulamaları ve içeriklerine
        yönelik herhangi bir sorumluluğumuz bulunmamaktadır.</span></p>

    <p class=MsoNormal align=center style='text-align:center'><span
        style='font-size:9.5pt;line-height:115%;font-family:"Times New Roman",serif'>Bireysel
        ve kurumsal üyelerimizin tüm bilgilerinin gizliliğini korumaya yönelik olarak <span class=SpellE>wep</span>
        sitemizde ve/veya uygulamalarımıza üye/kullanıcı adı ve
        şifre ile ulaşımınız sağlanmaktadır. Üyenin/Kullanıcının siteden/uygulamadan
        yararlanma hakkı sadece kendisine ait olup, başkalarına devredilemez ve
        kullandırılamaz. Üye/Kullanıcı adı ve şifresinin gizliliği ve sorumluluğu üye/kullanıcıya
        aittir. Üye/Kullanıcı adı ve şifrenin izinli veya izinsiz olarak üçüncü kişiler
        tarafından kullanımından doğabilecek durumlardan CDI sorumlu değildir. Bu gibi
        hallerde doğabilecek her türlü hukuki, idari ve cezai sorumluluk <span class=SpellE>üye’ye</span>/<span
          class=SpellE>kullanıcı’ya</span> aittir. Üye
        ve Kullanıcıların bu yükümlülüklerine ve sorumluluklarına aykırı davranması
        halinde, CDI, üye/kullanıcı hizmetlerini herhangi bir bildirimde bulunmaksızın
        tek taraflı olarak durdurma, üyeliği iptal etme, cezai ve hukuki başvuru
        haklarını kullanma ile uğradığı zararların tazmin edilmesini isteme hakkına
        sahiptir.<span style='mso-spacerun:yes'>  </span>Kullanıcı şifresinin izinsiz
        kullanımın tespit etmesi halinde derhal bu durumu <span class=SpellE>CDI’a</span>
        bildirmelidir. Güvenlik - gizlilik prensiplerine ve kullanım şartlarına uymayan
        veya bu hususta gerekli özeni göstermeyen üye/kullanıcı/abonmanın, bu aykırı
        davranışı nedeniyle olumsuz bir durumla karşılaşması halinde tüm sorumluluk
        kendisine aittir.</span></p>

    <p class=MsoNormal align=center style='text-align:center'><span
        style='font-size:9.5pt;line-height:115%;font-family:"Times New Roman",serif'>CDI,
        uygulama ve modüllerin; Kanunlara ve sitemizde yer verilen Gizlilik
        Prensiplerine, Üyelik veya Abonmanlık koşullarına, Sözleşme veya Kullanım
        Koşullarına aykırı olarak kullanıldığını tespit ederse ve/veya yetkili
        mercilerce bu konuda bir tespit veya inceleme talebi gelirse, üye/abonman/kullanıcı
        ile ilgili bilgileri yetkili makamlara ve işlem yapacak mali müşavir veya
        avukatlara bildirmek ve gerekli diğer tedbirleri alma hakkına sahiptir.</span></p>
  </div>
</div>
<div id="terms_of_use_modal" class="modal-wrapper" style="display: none">
  <h3>KULLANIM KOŞULLARI</h3>
  <p class=MsoNormal style='margin-bottom:0cm;line-height:normal'><span style='font-size:10.0pt;font-family:"Times New Roman",serif;mso-fareast-font-family:
    Calibri;color:black'></span></p>

  <p class=MsoNormal style='margin-bottom:0cm;text-align:justify;text-justify:
    inter-ideograph;line-height:normal'><b style='mso-bidi-font-weight:normal'><span style='font-size:10.0pt;font-family:"Times New Roman",serif;mso-fareast-font-family:
    Calibri;color:black'>1) Taraflar ve Tanımlar:</span></b></p>

  <p class=MsoNormal style='margin-bottom:0cm;text-align:justify;text-justify:
    inter-ideograph;line-height:normal'><b style='mso-bidi-font-weight:normal'><span style='font-size:10.0pt;font-family:"Times New Roman",serif;mso-fareast-font-family:
    Calibri;color:black'>1.1.</span></b><span style='font-size:10.0pt;font-family:
    "Times New Roman",serif;mso-fareast-font-family:Calibri;color:black'> Şirket<span style='mso-spacerun:yes'>       
      </span>:CDI Otomotiv Bilgi Hizmetleri A.Ş. -
      Car Data Internatıonal</span></p>

  <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
    margin-left:63.8pt;text-align:justify;text-justify:inter-ideograph;line-height:
    normal'><span style='font-size:10.0pt;font-family:"Times New Roman",serif;
    mso-fareast-font-family:Calibri;color:black'>Koşuyolu Mh. HaliliSk. No:9/2
      34718 Kadıköy / İstanbul, </span></p>

  <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
    margin-left:63.8pt;text-align:justify;text-justify:inter-ideograph;text-indent:
    -63.8pt;line-height:normal'><span style='font-size:10.0pt;font-family:"Times New Roman",serif;
    mso-fareast-font-family:Calibri;color:black'><span style='mso-spacerun:yes'>                      </span><span
        style='mso-tab-count:
    1'>    </span>Ticaret Sicil No: 828237, Mersis No: 0203031125400012</span></p>

  <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
    margin-left:63.8pt;text-align:justify;text-justify:inter-ideograph;text-indent:
    -63.8pt;line-height:normal'><span style='font-size:10.0pt;font-family:"Times New Roman",serif;
    mso-fareast-font-family:Calibri;color:black'><span style='mso-spacerun:yes'>                        </span><span
        style='mso-tab-count:
    1'>  </span>(kısaca Şirket veya CDI olarak anılacaktır)</span></p>

  <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
    margin-left:63.8pt;text-align:justify;text-justify:inter-ideograph;text-indent:
    -63.8pt;line-height:normal'><b style='mso-bidi-font-weight:normal'><span style='font-size:10.0pt;font-family:"Times New Roman",serif;mso-fareast-font-family:
    Calibri;color:black'>1.2.</span></b><span style='font-size:10.0pt;font-family:
    "Times New Roman",serif;mso-fareast-font-family:Calibri;color:black'> Uygulama:CDI’a
      ait ve web sitesi yahut mobil uygulama mağazalarında sunulan 2.El
      Fiyatlandırma, 2.El Araç Tedariki, Cardata, Araç(Katalog) Verileri, Aracınızın
      Güncel<span style='mso-spacerun:yes'>  </span>2.El<span style='mso-spacerun:yes'>  </span>Piyasa Değerini hemen
      öğren, Aracını
      Değerinde Hemen Sat, ve bunlarla sınırlı olmamak üzere mevcut ve ileride
      üretilecek veri analiz tabanlı her türlü ücretli, ücretsiz yazılım uygulamaları,
      modüller ve bunların demolarını,</span></p>

  <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
    margin-left:63.8pt;text-align:justify;text-justify:inter-ideograph;text-indent:
    -63.8pt;line-height:normal'><b style='mso-bidi-font-weight:normal'><span style='font-size:10.0pt;font-family:"Times New Roman",serif;mso-fareast-font-family:
    Calibri;color:black'>1.3.</span></b><span style='font-size:10.0pt;font-family:
    "Times New Roman",serif;mso-fareast-font-family:Calibri;color:black'> Kullanıcı<span style='mso-spacerun:yes'>  
      </span>:Kayıt ve üyelik esasıyla ücretli veya demo şeklinde
      ücretsiz olarak uygulama veya modülleri bireysel veya kurumsal amaçlarla kullanan
      gerçek ve tüzel kişileri</span></p>

  <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
    margin-left:63.8pt;text-align:justify;text-justify:inter-ideograph;text-indent:
    -63.8pt;line-height:normal'><b style='mso-bidi-font-weight:normal'><span style='font-size:10.0pt;font-family:"Times New Roman",serif;mso-fareast-font-family:
    Calibri;color:black'>1.4.</span></b><span style='font-size:10.0pt;font-family:
    "Times New Roman",serif;mso-fareast-font-family:Calibri;color:black'> Ziyaretçi
      <span style='mso-spacerun:yes'> </span>: Sistem üzerinden istenen bilgiler
      doğrultusunda form doldurarak hizmetten (örneğin 2.araç fiyatlandırması veya
      hemensat uygulaması gibi) faydalanan kişiyi,</span></p>

  <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
    margin-left:63.8pt;text-align:justify;text-justify:inter-ideograph;text-indent:
    -63.8pt;line-height:normal'><b style='mso-bidi-font-weight:normal'><span style='font-size:10.0pt;font-family:"Times New Roman",serif;mso-fareast-font-family:
    Calibri;color:black'>1.5. </span></b><span style='font-size:10.0pt;font-family:
    "Times New Roman",serif;mso-fareast-font-family:Calibri;color:black'><span
        style='mso-spacerun:yes'> </span>Üye<span style='mso-spacerun:yes'>       
      </span><span style='mso-spacerun:yes'>   </span>:2.El Araç Tedarigi
      uygulamasına kayıtlı muhtemel araç alıcısı olan kullanıcıları,</span></p>

  <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
    margin-left:63.8pt;text-align:justify;text-justify:inter-ideograph;text-indent:
    -63.8pt;line-height:normal'><b style='mso-bidi-font-weight:normal'><span style='font-size:10.0pt;font-family:"Times New Roman",serif;mso-fareast-font-family:
    Calibri;color:black'>1.6.</span></b><span style='font-size:10.0pt;font-family:
    "Times New Roman",serif;mso-fareast-font-family:Calibri;color:black'> E-Bülten :Abonelik
      veya üyelik esasıyla faydalanılan,<span style='mso-spacerun:yes'>  </span>sektörel
      bilgilerin, kampanayaların, satış kampanyalarının, iletişim kampanyalarının,
      özel tanıtımların, lansmanların, firma reklamlarının ulaştırıldığı <span style='mso-spacerun:yes'> </span>sektörel
      gelişme ve haberlerin yer aldığı
      bülteni</span></p>

  <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
    margin-left:63.8pt;text-align:justify;text-justify:inter-ideograph;text-indent:
    -63.8pt;line-height:normal'><b style='mso-bidi-font-weight:normal'><span style='font-size:10.0pt;font-family:"Times New Roman",serif;mso-fareast-font-family:
    Calibri;color:black'>1.7.</span></b><span style='font-size:10.0pt;font-family:
    "Times New Roman",serif;mso-fareast-font-family:Calibri;color:black'> Abone<span style='mso-spacerun:yes'> 
      </span>:Kaydolma esasına dayanan ve sıfır - 2.el
      otomobil fiyat rehberleri, dergi ve broşür gibi hizmetlerinden faydalanan,
      dijital ortamda bilgilerini girerek talepte bulunmuş ve kayıt yapmış gerçek
      veya tüzel kişileri</span></p>

  <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
    margin-left:63.8pt;text-align:justify;text-justify:inter-ideograph;text-indent:
    -63.8pt;line-height:normal'><b style='mso-bidi-font-weight:normal'><span style='font-size:10.0pt;font-family:"Times New Roman",serif;mso-fareast-font-family:
    Calibri;color:black'>1.8. </span></b><span style='font-size:10.0pt;font-family:
    "Times New Roman",serif;mso-fareast-font-family:Calibri;color:black'>Hizmetten
      Faydalanan: Bir bütün halinde, üyeler, aboneler, kullanıcılar, ziyaretçiler ve herhangi
      bir şekilde internet veya mobil uygulamalarımızdaki hizmetlerden faydalan tüm
      gerçek ve tüzel kişileri,</span></p>

  <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
    margin-left:63.8pt;text-align:justify;text-justify:inter-ideograph;text-indent:
    -63.8pt;line-height:normal'><b style='mso-bidi-font-weight:normal'><span style='font-size:10.0pt;font-family:"Times New Roman",serif;mso-fareast-font-family:
    Calibri;color:black'>1.9. </span></b><span style='font-size:10.0pt;font-family:
    "Times New Roman",serif;mso-fareast-font-family:Calibri;color:black'>Doğrulama:
      Üyelik veya abonelik kayıtlarının oluşturulması, ücretli veya demo
      uygulamalarda ziyaretçi veya kullanıcıların hizmetlerden faydalanabilmesi,
      ücretli uygulamalarda buna ilişkin süreçlerin yürütülebilmesi, sisteme girişte
      kullanabilmesi veya sorgulama yapılabilmesi gibi amaçlarla şirket veya iş
      ortakları tarafından muhatabının iletişim adresine (cep telefonu numarasına kısa
      mesaj veya mail adresine mesaj olarak) CDI tarafından oluşturularak ulaştırılan
      veya hizmetten faydalanan kişi tarafından oluşturulan şifre, kullanıcı adı,
      kodu, link gibi kişiye özel teyit/tanıma/giriş verisi yahut sembolünü yahut
      onaylama işlemini,</span></p>

  <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
    margin-left:63.8pt;text-align:justify;text-justify:inter-ideograph;text-indent:
    -63.8pt;line-height:normal'><b style='mso-bidi-font-weight:normal'><span style='font-size:10.0pt;font-family:"Times New Roman",serif;mso-fareast-font-family:
    Calibri;color:black'>1.10. </span></b><span style='font-size:10.0pt;font-family:
    "Times New Roman",serif;mso-fareast-font-family:Calibri;color:black'>Hizmet<span style='mso-spacerun:yes'>   
      </span><span style='mso-tab-count:1'> </span>:CDI
      tarafından, e-bülten, uygulama veya modül şeklinde sunulan, üyelik veya
      abonelik esasıyla ücretli veya ücretsiz demo veya ziyaretçi olarak
      faydalanılan, hali hazırda mevcut ve ileride CDI tarafından web sayfasında, IOS
      veya Android mağazalarında sunulacak CDI’a ait her türlü hizmeti,</span></p>

  <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
    margin-left:63.8pt;text-align:justify;text-justify:inter-ideograph;text-indent:
    -63.8pt;line-height:normal'><b style='mso-bidi-font-weight:normal'><span style='font-size:10.0pt;font-family:"Times New Roman",serif;mso-fareast-font-family:
    Calibri;color:black'>1.12. </span></b><span style='font-size:10.0pt;font-family:
    "Times New Roman",serif;mso-fareast-font-family:Calibri;color:black'>Sözleşme: Ücretli
      satışlarda her bir hizmet veya uygulama özelinde yapılan, elektronik onay
      şeklinde veya yazılı olarak akdedilen, Kullanım Koşullarının ve CDI’ın web veya
      mobil sitesinde yer alan diğer dokümanların her birisinin kendisinin eki olarak
      kabul edildiği taraflar arasında yapılmış anlaşmayı (ayrı bir sözleşmesi
      bulunmayan hizmetler için iş bu kullanım koşulları aynı zamanda Sözleşme
      hükmündedir.)</span></p>

  <p class=MsoNormal style='margin-bottom:0cm;text-align:justify;text-justify:
    inter-ideograph;line-height:normal'><span style='font-size:10.0pt;font-family:
    "Times New Roman",serif;mso-fareast-font-family:Calibri;color:black'>ifade
      etmektedir.</span><span style='font-size:10.0pt;font-family:"Helvetica",sans-serif;
    mso-fareast-font-family:"Times New Roman";mso-bidi-font-family:"Times New Roman";
    color:#242F62'></span></p>

  <p class=MsoNormal style='margin-bottom:0cm;line-height:normal'><span style='font-size:6.5pt;font-family:"Helvetica",sans-serif;mso-fareast-font-family:
    "Times New Roman";mso-bidi-font-family:"Times New Roman";color:#242F62'></span></p>

  <p class=MsoNormal style='margin-bottom:0cm;line-height:normal'><span style='font-size:6.5pt;font-family:"Helvetica",sans-serif;mso-fareast-font-family:
    "Times New Roman";mso-bidi-font-family:"Times New Roman";color:#242F62'></span></p>

  <p class=MsoNormal style='margin-bottom:0cm;text-align:justify;text-justify:
    inter-ideograph;line-height:normal'><b style='mso-bidi-font-weight:normal'><span style='font-size:10.0pt;font-family:"Times New Roman",serif;mso-fareast-font-family:
    Calibri;color:black'>2.) Uygulamalar/Modüller ve Hizmetler</span></b><span style='font-size:10.0pt;font-family:"Times New Roman",serif;mso-fareast-font-family:
    Calibri;color:black'>: </span></p>

  <p class=MsoNormal style='margin-bottom:0cm;text-align:justify;text-justify:
    inter-ideograph;line-height:normal'><b style='mso-bidi-font-weight:normal'><span style='font-size:10.0pt;font-family:"Times New Roman",serif;mso-fareast-font-family:
    Calibri;color:black'>2.1.</span></b><span style='font-size:10.0pt;font-family:
    "Times New Roman",serif;mso-fareast-font-family:Calibri;color:black'>&nbsp;Araç
      Fiyatlama:&nbsp;İnternet sitemizde yer alan ve IOS veya Android mağazalarında
      bulunan CDI’ ait Cardata Uygulaması, 2.El Araç Fiyatlandırma Uygulaması,
      Aracınızın Güncel 2.El Piyasa Değerini Hemen Öğren ve Hemen Sat uygulamalarında
      aracın olası maksimim-minimum veya ortalama değerini/aralığı veren
      sorgulamalar. </span></p>

  <p class=MsoNormal style='margin-bottom:0cm;text-align:justify;text-justify:
    inter-ideograph;line-height:normal'><b style='mso-bidi-font-weight:normal'><span style='font-size:10.0pt;font-family:"Times New Roman",serif;mso-fareast-font-family:
    Calibri;color:black'>2.2.</span></b><span style='font-size:10.0pt;font-family:
    "Times New Roman",serif;mso-fareast-font-family:Calibri;color:black'>&nbsp;E-Bülten:
      Sektörel bilgilerin, otomotiv kampanyalarının, satış veya alış kampanyalarının,
      iletişim kampanyalarının, özel tanıtımların, lansmanların ve benzeri gibi otomotiv
      sektörüyle ilgili gelişme, reklam ve haberlerin yer aldığı ve aktarıldığı bir bültendir.
      Abonmanların ücretsiz olarak kullanımına sunulmakta ve abonelerin<span style='mso-spacerun:yes'>  </span>e-mail
      adreslerine ve/veya cep telefonlarına
      gönderilmektedir. </span></p>

  <p class=MsoNormal style='margin-bottom:0cm;text-align:justify;text-justify:
    inter-ideograph;line-height:normal'><b style='mso-bidi-font-weight:normal'><span style='font-size:10.0pt;font-family:"Times New Roman",serif;mso-fareast-font-family:
    Calibri;color:black'>2.3.</span></b><span style='font-size:10.0pt;font-family:
    "Times New Roman",serif;mso-fareast-font-family:Calibri;color:black'> Araç
      (Katalog) Verileri: Marka / Model / Model Tipi Yapı Ağacı Datası, Teknik ve
      Donanım Datası, Geçmiş Yılların Araç Datası, 0 Km Araç Fiyatları, 2.El Araç
      Fiyatları, Araç Resim Datası verilerini içeren ücretli data setleridir.</span></p>

  <p class=MsoNormal style='margin-bottom:0cm;text-align:justify;text-justify:
    inter-ideograph;line-height:normal'><b style='mso-bidi-font-weight:normal'><span style='font-size:10.0pt;font-family:"Times New Roman",serif;mso-fareast-font-family:
    Calibri;color:black'>2.4 </span></b><span style='font-size:10.0pt;font-family:
    "Times New Roman",serif;mso-fareast-font-family:Calibri;color:black'>Demolar:
      CDI tarafından uygulama/modüllerin tanıtım amacıyla sunulmuş sınırlı ve/veya
      süreli halidir.</span></p>

  <p class=MsoNormal style='margin-bottom:0cm;line-height:normal'><b style='mso-bidi-font-weight:normal'><span style='font-size:10.0pt;font-family:
    "Times New Roman",serif;mso-fareast-font-family:Calibri;color:black'>2.5</span></b><span style='font-size:10.0pt;font-family:"Times New Roman",serif;mso-fareast-font-family:
    Calibri;color:black'>.Yukarıda belirtilenler ve bunlarla sınırlı olmamak üzere
      süreç içerisinde CDI tarafından geliştirilerek kullanıma sunulacak sair
      hizmetler/uygulamalar da aksi belirtilmedikçe işbu Kullanım Koşul ve
      Hükümlerine tabidir.</span></p>

  <p class=MsoNormal style='margin-bottom:0cm;line-height:normal'><span style='font-size:6.5pt;font-family:"Helvetica",sans-serif;mso-fareast-font-family:
    "Times New Roman";mso-bidi-font-family:"Times New Roman";color:#242F62'></span></p>

  <p class=MsoNormal style='margin-bottom:0cm;line-height:normal'><span style='font-size:6.5pt;font-family:"Helvetica",sans-serif;mso-fareast-font-family:
    "Times New Roman";mso-bidi-font-family:"Times New Roman";color:#242F62'></span></p>

  <p class=MsoNormal style='margin-bottom:0cm;line-height:normal'><b style='mso-bidi-font-weight:normal'><span style='font-size:10.0pt;font-family:
    "Times New Roman",serif;mso-fareast-font-family:Calibri;color:black'>3.)
        Kullanım Koşulları, <span style='mso-spacerun:yes'> </span>Sözleşme Hükümleri
        ve Bunların Mahiyeti;</span></b></p>

  <p class=MsoNormal style='margin-bottom:0cm;text-align:justify;text-justify:
    inter-ideograph;line-height:normal'><b style='mso-bidi-font-weight:normal'><span style='font-size:10.0pt;font-family:"Times New Roman",serif;mso-fareast-font-family:
    Calibri;color:black'>3.1. </span></b><span style='font-size:10.0pt;font-family:
    "Times New Roman",serif;mso-fareast-font-family:Calibri;color:black'>Kullanım
      Koşulları, CDI’a ait web tabanlı veya mobil hizmetlerimizden faydalanacak gerçek
      veya tüzel kişilerin genel olarak kullanıcılık, ziyaret, abonelik ve üyelik
      şartlarını, İnternet Sitesini/mobil uygulamalarının niteliklerini, kullanım koşullarını,
      hak ve yükümlülükleri, hizmetlerle ilgili hükümleri düzenlemekte olup, aynı
      zamanda ilgili hizmete dair Sözleşme’nin de ayrılmaz bir parçasıdır. Bu
      nedenle, işbu kullanım koşulları ile atıfta bulunduğu ve konusu itibariyle diğer
      uygulanabilir hükümleri, Sözleşme’nin ayrılmaz parçasıdır.</span></p>

  <p class=MsoNormal style='margin-bottom:0cm;text-align:justify;text-justify:
    inter-ideograph;line-height:normal'><b style='mso-bidi-font-weight:normal'><span style='font-size:10.0pt;font-family:"Times New Roman",serif;mso-fareast-font-family:
    Calibri;color:black'>3.2.</span></b><span style='font-size:10.0pt;font-family:
    "Times New Roman",serif;mso-fareast-font-family:Calibri;color:black'> Kullanım
      koşulları ve Sözleşme hükümleri; abonman veya üye olmak için kabul ettiğiniz
      koşullar, üye veya kullanıcı olarak İnternet Sitesini veya mobil uygulamayı
      kullanımınıza, hizmetlerden faydalanmanıza, bu bağlamda CDI tarafından sunulmuş
      hizmet ve ürünleri kullanmanıza ilişkin genel koşullar ve bunlara ek olarak her
      bir hizmet özelinde/ spesifik olarak özel </span><span style='font-size:10.0pt;
    font-family:"Times New Roman",serif;mso-fareast-font-family:Calibri'>Sözleşme<span style='color:black'>
        hükümlerinden oluşur. </span></span></p>

  <p class=MsoNormal style='margin-bottom:0cm;text-align:justify;text-justify:
    inter-ideograph;line-height:normal'><b style='mso-bidi-font-weight:normal'><span style='font-size:10.0pt;font-family:"Times New Roman",serif;mso-fareast-font-family:
    Calibri;color:black'>3.3.</span></b><span style='font-size:10.0pt;font-family:
    "Times New Roman",serif;mso-fareast-font-family:Calibri;color:black'> Genel
      olarak hizmetten faydalanma, CDI’ya ait İnternet Sitesi tarafından sağlanan
      hizmetleri kullanmak amacıyla bilgisayar, mobil cihaz veya farklı herhangi bir
      araçla bu siteye erişim sağlanması, cihazlara indirilmesi, İnternet Sitesi’nin
      ziyaret edilmesi/üye veya abone olunması ile uygulama ve modüllerin
      kullanılmasını ve sorgulama yapılması ve e-bülten bildirimleri gibi hususları içermektedir.
    </span></p>

  <p class=MsoNormal style='margin-bottom:0cm;text-align:justify;text-justify:
    inter-ideograph;line-height:normal'><b style='mso-bidi-font-weight:normal'><span style='font-size:10.0pt;font-family:"Times New Roman",serif;mso-fareast-font-family:
    Calibri;color:black'>3.4.</span></b><span style='font-size:10.0pt;font-family:
    "Times New Roman",serif;mso-fareast-font-family:Calibri;color:black'> Hizmetten
      faydalanan kişilerden topladığımız, bu kişilerin sağladıkları kişisel verilerin
      toplanması, işlenmesi ve aktarılması ile ilgili bilgilendirmeyi içeren dokümanlarımız
      (</span>
    <span>
      <a href="javascript:void(0)" class="privacy_policy"
        style='font-size:10.0pt;font-family:"Times New Roman",serif;mso-fareast-font-family:Calibri;color:#00B0F0'>Gizlilik
        Politikası</a>–
      <a href="javascript:void(0)" class="protection_of_personal_data"
        style='font-size:10.0pt;font-family:"Times New Roman",serif;mso-fareast-font-family:Calibri;color:#00B0F0'>Kişisel
        Verilerin İşlenmesi Hakkında Aydınlatma Metni ve Açık Rıza Beyanı</a></span>
    <span style='font-size:10.0pt;font-family:"Times New Roman",serif;mso-fareast-font-family:
    Calibri;color:black'>)<span style='mso-spacerun:yes'>  </span>sayfamızda yer
      almakta olup, onayınız ile verileriniz işlenmekte ve ilgili doküman kapsamında
      belirtilen koşullarla kullanılıp, paylaşılabilmektedir. </span>
  </p>

  <p class=MsoNormal style='margin-bottom:0cm;text-align:justify;text-justify:
    inter-ideograph;line-height:normal'><b style='mso-bidi-font-weight:normal'><span style='font-size:10.0pt;font-family:"Times New Roman",serif;mso-fareast-font-family:
    Calibri;color:black'>3.5.</span></b><span style='font-size:10.0pt;font-family:
    "Times New Roman",serif;mso-fareast-font-family:Calibri;color:black'> CDI
      sorgulama uygulamaları, ilgili ekranda çıkan ve sizin tarafınızdan girilecek
      bilgilere göre veri tabanı algoritması üzerinden otomatik olarak sonuç vermekte
      olduğundan tüm işlemleri gerçekleştirirken sizin doğru bilgileri verdiğiniz
      varsayımıyla hareket edilmektedir. Yanlış bilgi/veri girişi sebebiyle tüm
      sorumluluğun hizmetten faydalanan kişi olarak tarafınıza ait olduğunu kabul,
      beyan ve taahhüt etmektesiniz.</span></p>

  <p class=MsoNormal style='margin-bottom:0cm;text-align:justify;text-justify:
    inter-ideograph;line-height:normal'><b style='mso-bidi-font-weight:normal'><span style='font-size:10.0pt;font-family:"Times New Roman",serif;mso-fareast-font-family:
    Calibri;color:black'>3.6.</span></b><span style='font-size:10.0pt;font-family:
    "Times New Roman",serif;mso-fareast-font-family:Calibri;color:black'>
      Uygulamalarımızda/internet sayfamızda aracını satmak isteyen satıcıların
      (ZİYARETÇİ), aracını satma konusunda kendisi ile iletişime geçilmesini talep
      etmesi </span><span style='font-size:10.0pt;font-family:"Times New Roman",serif;
    mso-fareast-font-family:Calibri'>(Hemen Sat veya Aracınızı Hemen Değerinde Hemen
      Satın bölümünde yer alan <i style='mso-bidi-font-style:normal'>Sizinle İletişime
        Geçilsin Mi?</i> butonunu tıklayarak ve SMS olarak gönderilen doğrulama kodunu
      girerek)<span style='color:black'> halinde, muhtemel alıcı durumunda olan CDI
        uygulaması kullanıcılarına (otomobil bayileri, oto galerileri ve tedarikçisine)
        iletişim bilgisi ve yapılan sorgulamaya ait raporlama (sizin ekrandaki forma
        girilen temel araç bilgileri ve çıkan fiyatlandırmaya ait rapor) paylaşmakta ve
        Ziyaretçinin kendisiyle iletişime geçilmesi istediğini iletmekle
        yetinmekteyiz.<span style='mso-spacerun:yes'>  </span>Ancak CDI’ın buradaki tek
        rolü ve fonksiyonu muhtemel alıcı ile satıcıların birbirleri ile iletişime
        geçmesine yönelik isteği ve araç raporunu aktarmak olup, CDI hiçbir şekilde
        kullanıcı ile iletişime geçilmesini veya aracının satın alınmasını veya satış
        fiyatını taahhüt etmemektedir. </span></span><span style='font-size:10.0pt;
    font-family:"Times New Roman",serif'>Muhtemel alıcılar CDI’ın “2.El Araç Tedariği”
      uygulamasını kullanan ve CDI karşısında tıpkı ZİYARETÇİ gibi 3.kişi konumunda
      olan gerçek veya tüzel kişiler olup, bu kişilerin uygulamayı kullanma dışında
      CDI ile fiili, hukuki veya organik hiçbir bağı ve ilişkisi bulunmamaktadır.<span style='mso-spacerun:yes'> 
      </span></span><span style='font-size:10.0pt;
    font-family:"Times New Roman",serif;mso-fareast-font-family:Calibri;color:black'>CDI,
      muhtemel alıcı ve satıcı arasında gerçekleşebilecek iş, işlem ve ticaretin
      doğrudan veya dolaylı bir parçası, aracısı, garantörü, kefili veya tarafı
      olmayıp, CDI’ın taraflara ve aralarında yapacakları işlemlere dair hiçbir
      sorumluluğu bulunmamaktadır. Hizmetten faydalananlar bunu kabul, beyan ve
      taahhüt eder.</span></p>

  <p class=MsoNormal style='margin-bottom:0cm;text-align:justify;text-justify:
    inter-ideograph;line-height:normal'><b style='mso-bidi-font-weight:normal'><span style='font-size:10.0pt;font-family:"Times New Roman",serif;mso-fareast-font-family:
    Calibri;color:black'>3.7.</span></b><span style='font-size:10.0pt;font-family:
    "Times New Roman",serif;mso-fareast-font-family:Calibri;color:black'> CDI, aynı
      zamanda piyasa aktörlerine veri-modül-uygulama hizmet veren bir otomotiv datası
      şirketidir. Bu nedenle CDI’ın sahibi bulunduğu uygulamaların/modüllerin aynı
      veya farklı adlar altında ve yönetim paneli bu üçüncü kişilere ait olmak üzere
      onların internet sayfalarına link vermesi veya bu kişilere ait internet
      sayfalarına yerleştirilmesi mümkündür. Aynı şekilde bu kişilerin linklerine CDI,
      internet sitesinde de yer verilebilir. Ancak bağlantı içeriklerinde CDI’ın
      hiçbir etkisi yoktur. CDI bu sitelerde sunulan bilgilerin doğruluğu, güncelliği
      veya hizmet kalitesinden sorumlu tutulamaz. Bu gibi durumlarda, 3.kişilere ait
      internet sayfalarından yapılacak sorgulamalardan ve kurulacak ilişkilerden
      CDI’ın hiçbir sorumluluğu bulunmamaktadır. CDI tarafından link verilmesi veya
      kendi sayfasına link alınması,<span style='mso-spacerun:yes'>  </span>hiçbir
      şekilde CDI’ın diğer firma ya da kişi ile iş ortağı olduğu, aracılık yaptığı,
      birlikte hareket ettiği veya birlikte ticari faaliyette bulunduğu şeklinde
      yorumlanamaz. Bu nedenle, kullanıcının/hizmetten faydalanın, link üzerinden
      ulaştığı sayfa, bu sayfaların içeriği ve sayfa sahibi olan 3. kişilerle ilgili
      olarak ve keza kullanıcının bu kişi ile arasında olabilecek/yapılabilecek iş,
      işlem ve ticaretle ilgili olarak CDI’ın hiçbir ilgisi ve ilişkisi olmadığını,
      taraflar arasında kurulacak ilişkiye, ticarete, iş ve eylemlere ilişkin CDI’ın
      hiçbir sorumluluğu, taahhüt veya garantisi bulunmadığını Hizmetten Faydalanan bilir
      ve kabul eder. Bu nedenle hizmetten Faydalanan kişi, CDI’a karşı hiçbir hak,
      alacak veya zarar iddiasında bulunmayacağını, CDI’ın konuyla ve karşı taraf ile
      ilişkisi bulunduğunu doğrudan veya dolaylı iddia ve ima etmeyeceğini ve hiçbir
      şekilde CDI’a kusur ve sorumluluk atfetmeyeceğini kabul, beyan ve taahhüt eder.</span></p>

  <p class=MsoNormal style='margin-bottom:0cm;text-align:justify;text-justify:
    inter-ideograph;line-height:normal'><b style='mso-bidi-font-weight:normal'><span style='font-size:10.0pt;font-family:"Times New Roman",serif;mso-fareast-font-family:
    Calibri;color:black'>3.8</span></b><span style='font-size:10.0pt;font-family:
    "Times New Roman",serif;mso-fareast-font-family:Calibri;color:black'>
      Uygulamalar/modüller, 2.el bir aracın güncel referans piyasa değerlerini Türk
      Lirası cinsinden ve olası olarak veren bir uygulamadır. Modül, girilen verilere
      göre 2006 sonrası modelli araçların model tiplerinin 1.000 kilometre ile
      300.000 kilometre arasındaki referans, kaynak ve öngörü ikinci el değerlerinin
      referanslarını sunmaktadır. Ancak içinde bulunulan yıla ait modellerin
      verilerinin toplanması ve CDI açısından anlamlı hale gelmesinden sonrası
      sisteme yüklenebilmektedir.</span></p>

  <p class=MsoNormal style='margin-bottom:0cm;text-align:justify;text-justify:
    inter-ideograph;line-height:normal'><b style='mso-bidi-font-weight:normal'><span style='font-size:10.0pt;font-family:"Times New Roman",serif;mso-fareast-font-family:
    Calibri;color:black'>3.9.</span></b><span style='font-size:10.0pt;font-family:
    "Times New Roman",serif;mso-fareast-font-family:Calibri;color:black'> CDI,
      profesyonel ve bağımsız bir pazar gözlemcisi ve ikinci el fiyat datası
      sağlayıcısı şirketidir. Sözleşme konusu modülde/uygulamada sunulan ikinci el
      araç fiyatları, Cardata’nın Türkiye pazarı için kendi uzmanlığı, tecrübesi ve
      geliştirmiş olduğu know-how’a göre belirlenmiş ve sunmuş olduğu “referans”,
      “kaynak” ve “öngörü” değerlerdir. Modülde sunulan 2.el araçlar sadece binek
      otomobilleri ve hafif ticari araçları kapsamaktadır.</span></p>

  <p class=MsoNoSpacing style='text-align:justify;text-justify:inter-ideograph'><b
      style='mso-bidi-font-weight:normal'><span style='font-size:10.0pt;font-family:
    "Times New Roman",serif'>3.10.</span></b><span style='font-size:10.0pt;
    font-family:"Times New Roman",serif'> İkinci el araç değerleri göreceli bir
      kavram olmanın yanı sıra, kişiden kişiye, kurumdan kuruma ve aracın fiziki
      gerçek durumuna göre değişim gösterir. Türkiye otomotiv pazarında hiçbir ikinci
      el araç için kesin bir güncel fiyat değeri yoktur; çünkü ikinci el araç
      fiyatları araçların sahip oldukları donanım, aksesuar, motor, kaporta, hasar,
      kazar durumu, ekspertiz, kilometre, model yılı, şanzıman, yakıt tipi, yaş,
      kullanım şekli, yıpranışlık durumu, renk, şehir ve bölge gibi çok çeşitli
      faktörlere göre farklılıklar gösterir. Bu sebeplerden dolayı modülde sunulan
      ikinci el araç referans değerleri, araç sahibinin, alıcının, diğer kurum veya
      kişilerin belirlediği fiyatlara, diğer fiyat değerlendirme araçlarına,
      modüllerine ve uygulamalarına, hatta ve hatta Hizmetten Faydalanan’nın
      kendisinin belirlediği fiyatlara göre dahi fiyat farklılıkları gösterebilir. </span></p>

  <p class=MsoNoSpacing style='text-align:justify;text-justify:inter-ideograph'><b
      style='mso-bidi-font-weight:normal'><span style='font-size:10.0pt;font-family:
    "Times New Roman",serif'>3.11.</span></b><span style='font-size:10.0pt;
    font-family:"Times New Roman",serif'> Uygulama üzerinden yapılacak sorgulamada
      istenen tüm veriler, uygulamayı kullanan/Hizmetten Faydalanan kişi tarafından
      tek taraflı şekilde girilebilmektedir. CDI’ın sorgulama sırasında girilen bu
      bilgilerin doğruluğunu teyit etme imkanı ve sorumluluğu bulunmamaktadır. Hizmetten
      Faydalanan bunu bilir ve kabul eder. </span></p>

  <p class=MsoNoSpacing style='text-align:justify;text-justify:inter-ideograph'><b
      style='mso-bidi-font-weight:normal'><span style='font-size:10.0pt;font-family:
    "Times New Roman",serif'>3.12.</span></b><span style='font-size:10.0pt;
    font-family:"Times New Roman",serif'> Uygulamanın/Modülün sunmuş olduğu ikinci
      el araç değerleri, uygulamayı kullanacak kişi tarafından girilen verilere göre
      değişiklik arz eden ve nihayetinde fikir verici bir referans, kaynak ve öngörü
      değerleridir. Modülün sunmuş olduğu değerler herhangi bir kesinlik ifade
      etmemektedir. Uygulamaya, Hizmetten Faydalanan kullanıcı tarafından girilen
      bilgilerin (marka, model, model yılı, vites, hasar vs gibi uygulamada yer alan
      tek yönlü veri girişleri)<span style='mso-spacerun:yes'>  </span>doğruluğu ve
      gerçekliği hakkında CDI’ın teyit imkanının bulunmadığını, dolaysıyla CDI’ın, Hizmetten
      Faydalanan’a karşı hiçbir sorumluluğu ve taahhüdü bulunmadığını Hizmetten
      Faydalanan bilir ve kabul eder. </span></p>

  <p class=MsoNoSpacing style='text-align:justify;text-justify:inter-ideograph'><b
      style='mso-bidi-font-weight:normal'><span style='font-size:10.0pt;font-family:
    "Times New Roman",serif'>3.13.</span></b><span style='font-size:10.0pt;
    font-family:"Times New Roman",serif'> Uygulama Kullanıcısından beklenen,
      modülde oluşan fiyatların yine kendilerinin belirleyeceği 2.el araç fiyatlarına
      ön hazırlık, referans, öngörü ve kaynak olmasıdır. Yani uygulama fiyatlamasının
      fikir vermeye yönelik olduğunu Hizmetten Faydalanan bilir ve kabul eder.
      Dolayısıyla Hizmetten Faydalanan’ın uygulamayı kullanarak bulduğu araç
      değerleri üzerinden yapacağı 2.el araç alım-satım veya ticaretindeki tüm
      sorumluluk Hizmetten Faydalanan’a aittir. Hizmetten Faydalanan, uygulamada
      sunulan 2.el araç fiyatlarını kullanması nedeniyle CDI’a karşı zarar iddiasında
      ve tazminat talebinde bulunmayacağını gayrıkabili rücu kabul, beyan ve taahhüt
      eder.</span></p>

  <p class=MsoNoSpacing style='text-align:justify;text-justify:inter-ideograph'><b
      style='mso-bidi-font-weight:normal'><span style='font-size:10.0pt;font-family:
    "Times New Roman",serif'>3.14.</span></b><span style='font-size:10.0pt;
    font-family:"Times New Roman",serif'> CDI, uygulamada sunulan ikinci el araç
      fiyatlarını piyasadan, otomobil satıcılarından, otomobil bayilerinden ve otomobil
      yetkili satıcılarından (ikinci el araç satış kanallarından) topladığı (saha
      datasına) “araçların gerçekleşen satış fiyatlarına” göre belirler. Bu nedenle
      bu araç satış kanallarında olmayan, bu araç satış kanallarında satılmayan veya
      hiç satılmamış olan, bu araç satış kanallarından Cardata tarafından
      toplanamayan ve elde edilemeyen bazı markaların ve bazı araç modellerinin
      uygulamada yer almadığını ve dolayısıyla bu araçların 2.el fiyat datasının da
      uygulamada olmadığını Hizmetten Faydalanan bilir ve kabul eder.</span></p>

  <p class=MsoNoSpacing style='text-align:justify;text-justify:inter-ideograph'><b
      style='mso-bidi-font-weight:normal'><span style='font-size:10.0pt;font-family:
    "Times New Roman",serif'>3.15</span></b><span style='font-size:10.0pt;
    font-family:"Times New Roman",serif'>. Uygulamalarda veya internet sitemizde “Aracınızın
      Fiyatını Hemen Öğren” butonunu tıkladığınızda karşınıza çıkan ekrandaki
      bilgileri girdiğinizde araç veri sistemimizde otomatik olarak değerlendirmeye
      alınarak markası, modeli, model yılı, Km’si, hasar durumu gibi birtakım temel
      özellikleri girmeniz neticesinde karşınıza ortalama bir fiyat öngörüsü
      çıkacaktır. Bu fiyat veri tabanı üzerinden uygulamamızın türüne göre ortalama
      olarak bir fiyat yahut en az-en çok fiyat aralığı belirlenme şeklinde verilecektir.
      Ancak uygulamalar tam bir kesinlik ve doğru fiyatı belirlemeyi garanti veya
      taahhüt etmemektedir. Aracın özelliklerine ve fiili durumuna göre, başka
      platform veya kanallarda daha yüksek veya düşük fiyatlarla değerleme yapılması mümkün
      olup, bu durum alıcıdan alıcıya ve satıcıdan satıcıya, piyasa koşulları ve
      hareketliliğine, aracın fiziki muayene ve ekspertizine bağlı olarak değişebilmektedir.
      Uygulamalarımızda/internet sitemiz üzerinden yapacağınız sorgulamalarda çıkan
      fiyat veya fiyat aralığı veri tabanındaki bilgiler çerçevesinde olmakla
      birlikte nihayetinde bir öngörüdür, kullanıcıya/ziyaretçiye fikir vermeye amaçlamaktadır.
      Bu nedenle CDI’ın fiyatlandırma hususunda herhangi bir taahhüdü ve sorumluluğu bulunmamaktadır.
      Buradaki değerleme temel bir değerleme olup, aracın kesin veya esas satış
      fiyatı olmadığını Hizmetten Faydalanan bilir, kabul ve beyan eder.</span></p>

  <p class=MsoNormal style='margin-bottom:0cm;text-align:justify;text-justify:
    inter-ideograph;line-height:normal'><span style='font-size:10.0pt;font-family:
    "Times New Roman",serif;mso-fareast-font-family:Calibri;color:black'></span></p>

  <p class=MsoNormal style='margin-bottom:4.3pt;line-height:normal;background:
    white'><b style='mso-bidi-font-weight:normal'><span style='font-size:10.0pt;
    font-family:"Times New Roman",serif;mso-fareast-font-family:"Times New Roman";
    color:black;mso-themecolor:text1'>4.). Hizmetten/Uygulamadan Faydalanan Kişinin
        Yükümlülükleri ve Taahhütleri: </span></b></p>

  <p class=MsoNormal style='margin-bottom:0cm;text-align:justify;text-justify:
    inter-ideograph;background:white'><span style='font-size:10.0pt;line-height:
    115%;font-family:"Times New Roman",serif;mso-fareast-font-family:"Times New Roman";
    color:black;mso-themecolor:text1'>Hizmetten Faydalanan kişi
      (Kullanıcı/Üye/Ziyaretçi/Abone)</span></p>

  <p class=MsoNormal style='margin-bottom:0cm;text-align:justify;text-justify:
    inter-ideograph;background:white'><b><span style='font-size:10.0pt;line-height:
    115%;font-family:"Times New Roman",serif;mso-fareast-font-family:"Times New Roman";
    color:black;mso-themecolor:text1'>4.1.&nbsp;</span></b><span style='font-size:
    10.0pt;line-height:115%;font-family:"Times New Roman",serif;mso-fareast-font-family:
    "Times New Roman";color:black;mso-themecolor:text1'>İşbu Kullanım Koşullarını kabul
      etmekle, uygulamada yer alan, kullanıma ve hizmetlere ilişkin CDI tarafından
      belirlenen bilgi ve sistem güvenliği, kişisel verilerin korunması, uygulamaya
      giriş ve kullanım şartlarını,<br>
      <b>4.2.&nbsp;</b></span><span style='font-size:10.0pt;line-height:115%;
    font-family:"Times New Roman",serif;mso-fareast-font-family:"Times New Roman";
    color:red;mso-bidi-font-weight:bold'> </span><span style='font-size:10.0pt;
    line-height:115%;font-family:"Times New Roman",serif;mso-fareast-font-family:
    "Times New Roman";color:black;mso-themecolor:text1'>Uygulamaları web, Apple
      Store ve Google Play Store üzerinden ücretli veya ücretsiz olarak telefonuna
      yükleyerek, </span><span style='font-size:10.0pt;line-height:115%;font-family:
    "Times New Roman",serif;mso-fareast-font-family:"Times New Roman";color:black;
    mso-color-alt:windowtext'>kullanıcı adı ve oluşturulacak şifreyle</span><span style='font-size:10.0pt;line-height:115%;font-family:"Times New Roman",serif;
    mso-fareast-font-family:"Times New Roman";color:red'> </span><span style='font-size:10.0pt;line-height:115%;font-family:"Times New Roman",serif;
    mso-fareast-font-family:"Times New Roman";color:black;mso-themecolor:text1'>sisteme
      giriş sağlayarak, bilgilerin kendisine ait olduğunu, uygulama tarafından
      sunulan veriler ve bunlar dışındaki tüm e-belge olabilecek içerikleri (xml,
      html, ekran kopyası vb.) alan veya uygulama adlarını, görsellerini sözleşme
      ilkelerine aykırı amaçlarla kısmen veya tamamen kendisi veya üçüncü kişiler
      aracılığı ile kullanmayacağını, kopyalamayacağını, paylaşmayacağını,
      çoğaltmayacağını, ilave veya çıkartmalar yapmayacağını,</span></p>

  <p class=MsoNormal style='margin-bottom:0cm;text-align:justify;text-justify:
    inter-ideograph;background:white'><b><span style='font-size:10.0pt;line-height:
    115%;font-family:"Times New Roman",serif;mso-fareast-font-family:"Times New Roman";
    color:black;mso-themecolor:text1'>4.3.&nbsp;</span></b><span style='font-size:
    10.0pt;line-height:115%;font-family:"Times New Roman",serif;mso-fareast-font-family:
    "Times New Roman";color:black;mso-themecolor:text1;mso-bidi-font-weight:bold'>Hizmetten
      Faydalanan’ın, s</span><span style='font-size:10.0pt;line-height:115%;
    font-family:"Times New Roman",serif;mso-fareast-font-family:"Times New Roman";
    color:black;mso-themecolor:text1'>isteme erişim sağlayacağı cihazlarının
      donanımsal ve yazılımsal güvenliği ile varsa depolanan bilgilerin üçüncü
      kişilere karşı güvenliğinin sağlanması (virüs ve benzeri kötü amaçlı
      yazılımlar) konusunda sorumluluğun kendisine ait olduğunu ve bu gibi nedenlerle
      kendisinin ve/veya üçüncü kişilerin uğradığı veya uğrayabileceği zararlara dair
      sorumluluğu yüklendiğini,</span></p>

  <p class=MsoNormal style='margin-bottom:0cm;text-align:justify;text-justify:
    inter-ideograph;background:white'><b><span style='font-size:10.0pt;line-height:
    115%;font-family:"Times New Roman",serif;mso-fareast-font-family:"Times New Roman";
    color:black;mso-themecolor:text1'>4.4.&nbsp;</span></b><span style='font-size:
    10.0pt;line-height:115%;font-family:"Times New Roman",serif;mso-fareast-font-family:
    "Times New Roman";color:black;mso-themecolor:text1;mso-bidi-font-weight:bold'>Şifreli
      uygulamalarda,<b> </b>s</span><span style='font-size:10.0pt;line-height:115%;
    font-family:"Times New Roman",serif;mso-fareast-font-family:"Times New Roman";
    color:black;mso-themecolor:text1'>isteme erişimde başkasına ait şifre
      kullanmayacağını, kendi şifresini başkasına kullandırmayacağını, kendi
      yetkileri dışındaki bilgilere erişim sağlamayacağını, sistemin genel
      güvenliğini ve mevcut yazılımların çalışmasını yavaşlatacak veya engelleyecek
      uygulama, yazılım ve donanım kullanmayacağını, bu kapsamda hiçbir şekilde robot
      yazılım ve donanım kullanarak giriş, sorgu veya benzeri işlemler yapmayacağını,
      sözleşmenin amacına aykırı hareket etmeyeceğini, uygulama içeriğinde yer alan
      bilgileri değiştirip ekleme yapmayacağını, eriştiği verileri hukuka aykırı
      kullanıma neden olacak şekilde kendisinin veya uygulamaya giriş için kullandığı
      uygulama ve yazılımlar nedeniyle üçüncü kişi ya da kurumun depolamayacağını ve
      kullanmayacağını,</span></p>

  <p class=MsoNormal style='margin-bottom:0cm;text-align:justify;text-justify:
    inter-ideograph;background:white'><b><span style='font-size:10.0pt;line-height:
    115%;font-family:"Times New Roman",serif;mso-fareast-font-family:"Times New Roman";
    color:black;mso-themecolor:text1'>4.5.&nbsp;</span></b><span style='font-size:
    10.0pt;line-height:115%;font-family:"Times New Roman",serif;mso-fareast-font-family:
    "Times New Roman";color:black;mso-themecolor:text1'>Uygulama üzerinden sunulan
      hizmetin bilgilendirme amacıyla yapıldığını,</span><span style='font-size:10.0pt;
    line-height:115%;font-family:"Times New Roman",serif;mso-fareast-font-family:
    Calibri;color:black;mso-themecolor:text1'> </span><span style='font-size:10.0pt;
    line-height:115%;font-family:"Times New Roman",serif;mso-fareast-font-family:
    Calibri;color:black;mso-color-alt:windowtext'>CDI </span><span style='font-size:10.0pt;line-height:115%;font-family:"Times New Roman",serif;
    mso-fareast-font-family:"Times New Roman";color:black;mso-color-alt:windowtext'>android/app/</span><span style='font-size:10.0pt;line-height:115%;font-family:"Times New Roman",serif;
    mso-fareast-font-family:Calibri;color:black;mso-color-alt:windowtext'>wep
      sitesindeki “</span><span style='font-size:10.0pt;line-height:115%;font-family:
    "Times New Roman",serif;color:black;mso-color-alt:windowtext;background:white'>2.El
      Araç Tedariği Sağlama Uygulaması”</span><span style='font-size:10.0pt;
    line-height:115%;font-family:"Times New Roman",serif;mso-fareast-font-family:
    Calibri;color:black;mso-color-alt:windowtext'> “</span><span style='font-size:
    10.0pt;line-height:115%;font-family:"Times New Roman",serif;color:black;
    mso-color-alt:windowtext;background:white'>2.El Araç Fiyatlandırma Uygulaması”</span><span style='font-size:10.0pt;line-height:115%;font-family:"Times New Roman",serif;
    mso-fareast-font-family:Calibri;color:black;mso-color-alt:windowtext'> “Cardata
      Mobil Uygulaması” “Araç Kataloğ Verileri” “Hemen Sat” uygulaması, bunların
      demoları ve</span><span style='font-size:10.0pt;line-height:115%;font-family:
    "Times New Roman",serif;mso-fareast-font-family:Calibri;color:black;mso-themecolor:
    text1'> bunlarla sınırlı olmamak üzere mevcut veya ileride çıkartılacak sair
      uygulama ve ürünlerimizde çıkan referans fiyatlar ve bilgilerin, sadece
      öngörü/bilgilendirme amaçlı olduğunu, kesinlik içermediğini, alıcı ve satıcı
      arasında nihai fiyatlamasının aracın fiziki durumu, muayenesi, ekspertiz ve
      benzeri gibi aracın gerçek durumuna göre değiştiğini bildiğini, hiçbir şekilde
      asgari bir fiyatlama yahut CDI tarafından doğrudan veya dolaylı olarak yapılmış
      bir araç satın alma taahhüdü, teklifi, icap veya kabulü anlamına gelmediğini,
      nihai olarak uygulamanın amacının araç alıcı veya satıcıları için değer
      hakkında olası / fikir vermeye yönelik bir değerlendirmeden ve talep halinde
      iletişime geçilmesini teminen iletişim bilgisini aktarmaktan ibaret olduğunu,
      bundan sonrasına ilişkin olarak sürece dair her hangi bir dahili, taahhüdü ve
      sorumluluğu bulunmadığını,</span></p>

  <p class=MsoNormal style='margin-bottom:4.3pt;text-align:justify;text-justify:
    inter-ideograph;background:white'><b style='mso-bidi-font-weight:normal'><span style='font-size:10.0pt;line-height:115%;font-family:"Times New Roman",serif;
    mso-fareast-font-family:"Times New Roman";color:black;mso-themecolor:text1'>4.6.</span></b><span style='font-size:10.0pt;line-height:115%;font-family:"Times New Roman",serif;
    mso-fareast-font-family:"Times New Roman";color:black;mso-themecolor:text1'>
      Kendisine ait her türlü cihaz, yazılım ve donanımdan kaynaklı eksiklik, arıza
      ve kesinti ile internet servis sağlayıcılarından kaynaklanan kesinti veya
      arızadan dolayı hizmetlerden faydalanamaması veya süresinde işlem yapamaması
      halinde sorumluluğun kendisine ait olduğunu, uygulamaya yanlış veya eksik veri
      girişi durumunda veya doğruluğu halinde dahi CDI’ın herhangi bir sorumluluğunun
      olmadığını,</span></p>

  <p class=MsoNormal style='margin-bottom:4.3pt;text-align:justify;text-justify:
    inter-ideograph;background:white'><b><span style='font-size:10.0pt;line-height:
    115%;font-family:"Times New Roman",serif;mso-fareast-font-family:"Times New Roman";
    color:black;mso-themecolor:text1'>4.7.&nbsp;</span></b><span style='font-size:
    10.0pt;line-height:115%;font-family:"Times New Roman",serif;mso-fareast-font-family:
    "Times New Roman";color:black;mso-themecolor:text1'>Sisteminin kullanımı, bakım
      ve idamesi, sistem güvenliğine yönelik çalışmalar ve güncellemeler sırasında ortaya
      çıkabilecek kısıtlama, cihaz arızası, iletişim kesintisi, iletişim yavaşlığı,
      hat yoğunluğu ve diğer idari veya teknik nedenlerden dolayı uygulama üzerinden
      sunulan hizmetlerin ilgili sistem üzerinden hizmetin yerine getirilememesi
      durumunda CDI’ın herhangi bir sorumluluğunun olmadığını,</span></p>

  <p class=MsoNormal style='margin-bottom:4.3pt;text-align:justify;text-justify:
    inter-ideograph;background:white'><b><span style='font-size:10.0pt;line-height:
    115%;font-family:"Times New Roman",serif;mso-fareast-font-family:"Times New Roman";
    color:black;mso-themecolor:text1'>4.8.&nbsp;</span></b><span style='font-size:
    10.0pt;line-height:115%;font-family:"Times New Roman",serif;mso-fareast-font-family:
    "Times New Roman";color:black;mso-themecolor:text1'>CDI’ın kendiliğinden,
      hizmet gereği veya teknik zorunluluklar nedeniyle, tek taraflı olarak sistemi
      sürekli veya geçici olarak durdurma, uygulama içeriğini değiştirme, ücretli
      uygulamalarda sözleşme hükümleri saklı kalmak kaydıyla kısıtlama veya iptal
      etme hakkının olduğunu,</span></p>

  <p class=MsoNormal style='margin-bottom:4.3pt;text-align:justify;text-justify:
    inter-ideograph;background:white'><b><span style='font-size:10.0pt;line-height:
    115%;font-family:"Times New Roman",serif;mso-fareast-font-family:"Times New Roman";
    color:black;mso-themecolor:text1'>4.9.&nbsp;</span></b><span style='font-size:
    10.0pt;line-height:115%;font-family:"Times New Roman",serif;mso-fareast-font-family:
    "Times New Roman";color:black;mso-themecolor:text1'>CDI’ın uygulamalar ve
      e-bülten üzerinden kendisinin ve başka bir şirketin duyuru, ilan, mesaj, anket,
      reklam, tanıtım, duyuru <span style='mso-spacerun:yes'> </span>vb. işlemler
      yapabileceğini, </span></p>

  <p class=MsoNormal style='margin-bottom:4.3pt;text-align:justify;text-justify:
    inter-ideograph;background:white'><b><span style='font-size:10.0pt;line-height:
    115%;font-family:"Times New Roman",serif;mso-fareast-font-family:"Times New Roman";
    color:black;mso-themecolor:text1'>4.10.&nbsp;</span></b><span style='font-size:
    10.0pt;line-height:115%;font-family:"Times New Roman",serif;mso-fareast-font-family:
    "Times New Roman";color:black;mso-themecolor:text1'>CDI’ın sunduğu hizmetin sürekliliğini
      veya hizmet kalitesini arttırmak için, tek taraflı değişiklik yapma hakkına
      sahip olduğunu, ücretsiz hizmetlere ilişkin sözleşmede ve kullanım koşullarında
      gerçekleştirilecek değişiklikler kullanıcı tarafından onaylanmadıkça uygulamaya
      giriş yapamayacağını,&nbsp;</span></p>

  <p class=MsoNormal style='margin-bottom:4.3pt;text-align:justify;text-justify:
    inter-ideograph;background:white'><b><span style='font-size:10.0pt;line-height:
    115%;font-family:"Times New Roman",serif;mso-fareast-font-family:"Times New Roman";
    color:black;mso-themecolor:text1'>4.11.</span></b><span style='font-size:10.0pt;
    line-height:115%;font-family:"Times New Roman",serif;mso-fareast-font-family:
    "Times New Roman";color:black;mso-themecolor:text1'>&nbsp;Sisteme saldırı
      mahiyetinde eylemlerinin tespiti halinde uygulamaya giriş işleminin süreli veya
      süresiz olarak kısıtlanacağını ve ilgililer hakkında yasal işlemlere
      başlanacağını, </span></p>

  <p class=MsoNormal style='margin-bottom:4.3pt;text-align:justify;text-justify:
    inter-ideograph;background:white'><b><span style='font-size:10.0pt;line-height:
    115%;font-family:"Times New Roman",serif;mso-fareast-font-family:"Times New Roman";
    color:black;mso-themecolor:text1'>4.12.</span></b><span style='font-size:10.0pt;
    line-height:115%;font-family:"Times New Roman",serif;mso-fareast-font-family:
    "Times New Roman";color:black;mso-themecolor:text1'>&nbsp;Sözleşmeye aykırı
      davranışlar nedeniyle CDI’ın uğrayacağı veya kişi ve/veya kurumlara ödemek
      zorunda kalabileceği her türlü tazminat ve cezalar için kullanıcıdan talep veya
      kullanıcıya rücu hakkına haiz olduğunu,</span></p>

  <p class=MsoNormal style='margin-bottom:4.3pt;text-align:justify;text-justify:
    inter-ideograph;background:white'><b style='mso-bidi-font-weight:normal'><span style='font-size:10.0pt;line-height:115%;font-family:"Times New Roman",serif;
    mso-fareast-font-family:"Times New Roman";color:black;mso-themecolor:text1'>4.13.</span></b><span style='font-size:10.0pt;line-height:115%;font-family:"Times New Roman",serif;
    mso-fareast-font-family:"Times New Roman";color:black;mso-themecolor:text1'> <span
        style='mso-spacerun:yes'> </span>Hizmetin, sözleşmenin akdi tarihinde<span style='mso-spacerun:yes'> 
      </span>“Olduğu Gibi” sunulduğunu ve CDI’ın,
      kullanıcıların kendine özel ihtiyaçlarını tamamen karşılayacağı şeklinde bir
      iddia veya taahhütte bulunmadığını,</span></p>

  <p class=MsoNormal style='margin-bottom:4.3pt;text-align:justify;text-justify:
    inter-ideograph;line-height:normal;background:white'><b style='mso-bidi-font-weight:
    normal'><span style='font-size:10.0pt;font-family:"Times New Roman",serif;
    mso-fareast-font-family:"Times New Roman";color:black;mso-themecolor:text1'>4.14.</span></b><span style='font-size:10.0pt;font-family:"Times New Roman",serif;mso-fareast-font-family:
    "Times New Roman";color:black;mso-themecolor:text1'> Hizmetlere erişim
      kalitesinin büyük ölçüde kullandığı internet servis sağlayıcısının hizmet kalitesine
      bağlı olduğunu ve söz konusu hizmet kalitesinden kaynaklı sorunlarda CDI’ın
      herhangi bir sorumluluğunun bulunmadığını,</span></p>

  <p class=MsoNormal style='margin-bottom:4.3pt;text-align:justify;text-justify:
    inter-ideograph;line-height:normal;background:white'><b style='mso-bidi-font-weight:
    normal'><span style='font-size:10.0pt;font-family:"Times New Roman",serif;
    mso-fareast-font-family:"Times New Roman";color:black;mso-themecolor:text1'>4.15.</span></b><span style='font-size:10.0pt;font-family:"Times New Roman",serif;mso-fareast-font-family:
    "Times New Roman";color:black;mso-themecolor:text1'> </span><span style='font-size:10.0pt;font-family:"Times New Roman",serif;color:#333333;
    background:white'>CDI’ın istediği zaman ve gerekçe göstermeden, bildirimde
      bulunmadan ve her hangi bir hukuki sorumluluğu olmadan E-Bülten Aboneliğini,
      feshedebileceğini, geçici veya sürekli olarak durdurabileceğini, </span><span style='font-size:10.0pt;font-family:"Times New Roman",serif;mso-fareast-font-family:
    "Times New Roman";color:black;mso-themecolor:text1'></span></p>

  <p class=MsoNormal style='margin-bottom:4.3pt;text-align:justify;text-justify:
    inter-ideograph;line-height:normal;background:white'><b style='mso-bidi-font-weight:
    normal'><span style='font-size:10.0pt;font-family:"Times New Roman",serif;
    mso-fareast-font-family:"Times New Roman";color:black;mso-themecolor:text1'>4.15.
      </span></b><span><a href="javascript:void(0)" class="protection_of_personal_data" style='font-size:10.0pt;font-family:"Times New Roman",serif;
        mso-fareast-font-family:"Times New Roman";color:#0070C0'>Kişisel Verilerinin
        İşlenmesi Hakkında Aydınlatma Metnini</a></span><span style='font-size:10.0pt;
    font-family:"Times New Roman",serif;mso-fareast-font-family:"Times New Roman";
    color:black;mso-themecolor:text1'> okuduğunu ve kişisel verilerin işlenmesine
      ilişkin Açık Rızayı verdiğini, </span></p>

  <p class=MsoNormal style='margin-bottom:4.3pt;text-align:justify;text-justify:
    inter-ideograph;line-height:normal;background:white'><b style='mso-bidi-font-weight:
    normal'><span style='font-size:10.0pt;font-family:"Times New Roman",serif;
    mso-fareast-font-family:"Times New Roman";color:black;mso-themecolor:text1'>Kabul
        Beyan Ve Taahhüt Etmiştir. </span></b></p>

  <p class=MsoNormal style='margin-bottom:0cm;text-align:justify;text-justify:
    inter-ideograph'><span style='font-family:"Times New Roman",serif;mso-fareast-font-family:
    Calibri;color:black'></span></p>

  <p class=MsoNormal style='margin-bottom:0cm;text-align:justify;text-justify:
    inter-ideograph'><b style='mso-bidi-font-weight:normal'><span style='font-size:
    10.0pt;line-height:115%;font-family:"Times New Roman",serif;mso-fareast-font-family:
    Calibri;color:black'>5. Kullanım Koşullarının Sözleşmenin Eki ve Ayrılmaz Bir
        Parçası Olması:</span></b><span style='font-size:10.0pt;line-height:115%;
    font-family:"Times New Roman",serif;mso-fareast-font-family:Calibri;color:black'>
      İşbu Kullanım Koşulları aynı zamanda, düzenlediği konu bakımından sizinle
      aramızda yapılacak sözleşmenin ayrılmaz bir parçasıdır. İşbu Kullanım
      Koşullarında veya hizmetlerden faydalanmaya ve sözleşmeye onay vermeniz halinde
      aramızda yapılacak/yapılmış olacak </span><span style='font-size:10.0pt;
    line-height:115%;font-family:"Times New Roman",serif;mso-fareast-font-family:
    Calibri'>Sözleşmede<span style='color:#0070C0'> </span><span style='color:black'>yer
        alanlar dışında hiçbir beyan, açıklama, taahhüt, güvence veya garanti
        vermediğimiz kabul etmiş olursunuz..</span></span></p>

  <p class=MsoNormal style='margin-bottom:0cm;text-align:justify;text-justify:
    inter-ideograph'><span style='font-size:5.0pt;line-height:115%;font-family:
    "Times New Roman",serif;mso-fareast-font-family:Calibri;color:black'></span></p>

  <p class=MsoNormal style='margin-bottom:0cm;text-align:justify;text-justify:
    inter-ideograph'><b style='mso-bidi-font-weight:normal'><span style='font-size:
    10.0pt;line-height:115%;font-family:"Times New Roman",serif;mso-fareast-font-family:
    Calibri;color:black'>6.</span></b><span style='font-size:10.0pt;line-height:
    115%;font-family:"Times New Roman",serif;mso-fareast-font-family:Calibri;
    color:black'> <b style='mso-bidi-font-weight:normal'>Kabul Beyanı, Anlaşma ve
        KVK :</b> İnternet Sitesinin ve uygulamaları kullanımı, üye ve abonmanlık
      kaydını işlemleri sırasında elektronik form üzerinde ve/veya işlem adımlarında
      SMS olarak size gelen doğrulama kodunu girmekle işbu Kullanım Koşullarını ve
      Sözleşme Hükümlerini kabul ettiğiniz ve belirtilen tüm koşullara uygun şekilde
      davranacağınızı ve kişisel verilerinizin işlenmesine açık rıza verdiğinizi
      kabul, beyan ve taahhüt etmiş olursunuz.</span></p>

  <p class=MsoNormal style='margin-bottom:0cm;text-align:justify;text-justify:
    inter-ideograph'><span style='font-size:5.0pt;line-height:115%;font-family:
    "Times New Roman",serif;mso-fareast-font-family:Calibri;color:black'></span></p>

  <p class=MsoNormal style='margin-bottom:0cm;text-align:justify;text-justify:
    inter-ideograph'><b style='mso-bidi-font-weight:normal'><span style='font-size:
    10.0pt;line-height:115%;font-family:"Times New Roman",serif;mso-fareast-font-family:
    Calibri;color:black'>7. Koşullarda Değişiklik Yapma Hakkı: </span></b></p>

  <p class=MsoNormal style='margin-bottom:0cm;text-align:justify;text-justify:
    inter-ideograph'><span style='font-size:10.0pt;line-height:115%;font-family:
    "Times New Roman",serif;mso-fareast-font-family:"Times New Roman";color:black;
    mso-themecolor:text1'>Ücretli uygulamalarda Sözleşmenin akdi tarihindeki kullanım
      koşulları, kazanılmış haklar ve tarafların yükümlülükleri saklı kalmak
      kaydıyla, <span style='mso-spacerun:yes'> </span>CDI önceden herhangi bir
      bildirimde bulunmaksızın kendiliğinden tek </span><span style='font-size:10.0pt;
    line-height:115%;font-family:"Times New Roman",serif;mso-fareast-font-family:
    Calibri;color:black'>taraflı olarak Kullanım Koşullarını değiştirme, sistemi
      sürekli veya geçici olarak durdurma, uygulama veya e-bülten içeriğini
      değiştirme, kısıtlama veya iptal etmekte serbesttir.<b style='mso-bidi-font-weight:
    normal'> </b></span></p>

  <p class=MsoNormal style='margin-bottom:0cm;text-align:justify;text-justify:
    inter-ideograph'><b style='mso-bidi-font-weight:normal'><span style='font-size:
    5.0pt;line-height:115%;font-family:"Times New Roman",serif;mso-fareast-font-family:
    Calibri;color:black'></span></b></p>

  <p class=MsoNormal style='margin-bottom:0cm;text-align:justify;text-justify:
    inter-ideograph'><b style='mso-bidi-font-weight:normal'><span style='font-size:
    10.0pt;line-height:115%;font-family:"Times New Roman",serif;mso-fareast-font-family:
    Calibri;color:black'>8. Hizmet Güncellemeleri Ve Değişiklikleri</span></b></p>

  <p class=MsoNormal style='margin-bottom:0cm;text-align:justify;text-justify:
    inter-ideograph'><span style='font-size:10.0pt;line-height:115%;font-family:
    "Times New Roman",serif;mso-fareast-font-family:"Times New Roman";color:black;
    mso-themecolor:text1'>CDI, internet sitesini ve verdiği hizmetleri güncelleme
      ve içeriğini değiştirme hakkına sahiptir. Ancak CDI,<span style='mso-spacerun:yes'>  </span>internet sitesi,
      uygulama ve modüller gibi
      sair hizmetlerin güncel, hatasız veya eksiksiz olduğunu garanti ve taahhüt etmez.
      CDI, en iyi hizmeti hedeflemekle ve bu yolda çalışmakla birlikte, bu hususta
      kesin bir taahhüdü </span><span style='font-size:10.0pt;line-height:115%;
    font-family:"Times New Roman",serif;mso-fareast-font-family:Calibri;color:black'>ve
      yükümlülüğü bulunmamaktadır.</span></p>

  <p class=MsoNormal style='margin-bottom:0cm;text-align:justify;text-justify:
    inter-ideograph'><b style='mso-bidi-font-weight:normal'><span style='font-size:
    5.0pt;line-height:115%;font-family:"Times New Roman",serif;mso-fareast-font-family:
    Calibri;color:black'></span></b></p>

  <p class=MsoNormal style='margin-bottom:0cm;text-align:justify;text-justify:
    inter-ideograph'><b style='mso-bidi-font-weight:normal'><span style='font-size:
    10.0pt;line-height:115%;font-family:"Times New Roman",serif;mso-fareast-font-family:
    Calibri;color:black'>9. Ücretlendirme, Ürün Demoları<span style='mso-spacerun:yes'>  </span>ve Devir
        Yasağı</span></b></p>

  <p class=MsoNormal style='margin-bottom:4.3pt;text-align:justify;text-justify:
    inter-ideograph;background:white'><span style='font-size:10.0pt;line-height:
    115%;font-family:"Times New Roman",serif;mso-fareast-font-family:"Times New Roman";
    color:black;mso-themecolor:text1'>CDI’ya ait İnternet sitesinde yer alan ve IOS
      veya Android mağazalarında bulunan hizmetlerden hangilerinin ücretli veya
      ücretsiz olacağına yahut hangisinin demosunu sunulacağına hakkı ve yetkisi
      münhasıran CDI’a aittir. CDI ücretsiz uygulama ve hizmetleri her zaman ücretli
      hale getirme hakkına sahiptir. Bu durum hizmetten faydalanan için hiçbir
      şekilde kazanılmış hak teşkil etmez.</span><span style='font-size:10.0pt;
    line-height:115%;font-family:"Times New Roman",serif;mso-fareast-font-family:
    "Times New Roman";color:#242F62'></span></p>

  <p class=MsoNormal style='margin-bottom:4.3pt;text-align:justify;text-justify:
    inter-ideograph'><span style='font-size:10.0pt;line-height:115%;font-family:
    "Times New Roman",serif;mso-fareast-font-family:"Times New Roman";color:black;
    mso-themecolor:text1'>CDI’ya ait İnternet sitesinde yer alan ve IOS veya
      Android mağazalarında bulunan sorgulama sonuçları ile üyelere ait sitelerdeki
      uygulamalarda çıkacak fiyatlar ve genel olarak da güncel durumu arasında
      farklılık olabilir. CDI, bu bilgilerin güncelliği ve doğruluğu, üye uygulama
      kullanıcılarının sitelerindeki sorgulama sonuçları gibi hususlarda hakkında
      herhangi bir garanti verilmemekte ve taahhütte bulunulmamaktadır.</span></p>

  <p class=MsoNormal style='margin-bottom:0cm;text-align:justify;text-justify:
    inter-ideograph'><span style='font-size:10.0pt;line-height:115%;font-family:
    "Times New Roman",serif;mso-fareast-font-family:"Times New Roman";color:black;
    mso-themecolor:text1'>Kullanıcı, CDI’ın yazılı onayını almaksızın işbu kullanım
      koşulları’ndaki ve sözleşmedeki haklarını veya </span><span style='font-size:
    10.0pt;line-height:115%;font-family:"Times New Roman",serif;mso-fareast-font-family:
    Calibri;color:black'>yükümlülüklerini kısmen veya tamamen devredemez. </span></p>

  <p class=MsoNormal style='margin-bottom:0cm;text-align:justify;text-justify:
    inter-ideograph'><b style='mso-bidi-font-weight:normal'><span style='font-size:
    5.0pt;line-height:115%;font-family:"Times New Roman",serif;mso-fareast-font-family:
    Calibri;color:black'></span></b></p>

  <p class=MsoNormal style='margin-bottom:0cm;text-align:justify;text-justify:
    inter-ideograph'><b style='mso-bidi-font-weight:normal'><span style='font-size:
    10.0pt;line-height:115%;font-family:"Times New Roman",serif;mso-fareast-font-family:
    Calibri;color:black'>10. <span style='mso-spacerun:yes'> </span>Hizmetlere
        Ulaşım ve Güvenlik: </span></b></p>

  <p class=MsoNormal style='margin-bottom:0cm;text-align:justify;text-justify:
    inter-ideograph'><span style='font-size:10.0pt;line-height:115%;font-family:
    "Times New Roman",serif;mso-fareast-font-family:"Times New Roman";color:black;
    mso-themecolor:text1'>CDI, mevcut hizmet yazılımlarının her cihaz ya da web
      tarayıcı ile uyumlu olduğuna dair bir taahhütte </span><span style='font-size:
    10.0pt;line-height:115%;font-family:"Times New Roman",serif;mso-fareast-font-family:
    Calibri;color:black'>bulunmamaktadır.</span></p>

  <p class=MsoNormal style='margin-bottom:0cm;text-align:justify;text-justify:
    inter-ideograph'><b style='mso-bidi-font-weight:normal'><span style='font-size:
    5.0pt;line-height:115%;font-family:"Times New Roman",serif;mso-fareast-font-family:
    Calibri;color:black'></span></b></p>

  <p class=MsoNormal style='margin-bottom:0cm;text-align:justify;text-justify:
    inter-ideograph;mso-layout-grid-align:none;text-autospace:none'><span style='font-size:10.0pt;line-height:115%;font-family:"Times New Roman",serif;
    mso-fareast-font-family:"Times New Roman";color:black;mso-themecolor:text1'>CDI
      olarak, virüs ve benzeri kötü amaçlı yazılımlardan arındırılmış olması için
      piyasadaki benzer standartlar dahilinde tedbir almaktayız.<span style='mso-spacerun:yes'>  </span>Sizde, hizmete
      erişimde kullandığınız
      bilgisayar ve mobil cihazlarınız için, kötü ve zarar verme amaçlı yazılım veya
      virüslere karşı tedbirleri almak yükümlülüğüsünüz. Aksi taktirde, kötü amaçlı
      program ve yazılımlar nedeniyle hizmete erişimde yaşanabilecek, hata, aksaklık,
      gecikmelerden dolayı veya sizin veya üçüncü kişilerin uğrayabileceği zarardan CDI
      sorumlu değildir.</span></p>

  <p class=MsoNormal style='margin-bottom:0cm;mso-layout-grid-align:none;
    text-autospace:none'><span style='font-size:5.0pt;line-height:115%;font-family:
    "Times New Roman",serif;mso-fareast-font-family:"Times New Roman";color:black;
    mso-themecolor:text1'></span></p>

  <p class=MsoNormal style='margin-bottom:0cm;text-align:justify;text-justify:
    inter-ideograph'><span style='font-size:10.0pt;line-height:115%;font-family:
    "Times New Roman",serif;mso-fareast-font-family:"Times New Roman";color:black;
    mso-themecolor:text1'>Hizmetten Faydalanan kişilerin, CDI sistemlerinin
      güvenliğini tehdit edebilecek girişimlerde bulunması veya uygulamamalara, CDI’a
      ve diğer kullanıcılara zarar verebilecek eylemlerde bulunması, kaynak kodlarına
      veya CDI’ın sistemlerine yetkisiz bir şekilde erişmesi, bu bilgileri
      kopyalaması, silmesi, değiştirmesi ya da bu yönde denemeler yapması yasaktır.
      Böyle bir durumun veya girişimin tespiti halinde CDI ilgililer hakkında her
      türlü </span><span style='font-size:10.0pt;line-height:115%;font-family:"Times New Roman",serif;
    mso-fareast-font-family:Calibri;color:black'>cezai ve hukuk haklarını
      kullanacaktır.</span></p>

  <p class=MsoNormal style='margin-bottom:0cm;text-align:justify;text-justify:
    inter-ideograph'><span style='font-size:10.0pt;line-height:115%;font-family:
    "Times New Roman",serif;mso-fareast-font-family:Calibri;color:black'></span></p>

  <p class=MsoNormal style='margin-bottom:0cm;text-align:justify;text-justify:
    inter-ideograph'><b style='mso-bidi-font-weight:normal'><span style='font-size:
    10.0pt;line-height:115%;font-family:"Times New Roman",serif;mso-fareast-font-family:
    Calibri;color:black'>11. Mücbir Sebep:</span></b></p>

  <p class=MsoNormal style='margin-bottom:0cm;text-align:justify;text-justify:
    inter-ideograph'><span style='font-size:10.0pt;line-height:115%;font-family:
    "Times New Roman",serif;mso-fareast-font-family:Calibri;color:black'>Hizmetin</span><span style='font-size:10.0pt;line-height:115%;font-family:"Times New Roman",serif;
    mso-fareast-font-family:"Times New Roman";color:black;mso-themecolor:text1'>
      sunulmasını engelleyen mücbir sebep sayılan tüm durumlarda, CDI Sözleşme ile
      belirlenen edimlerinden herhangi birini; geç veya eksik ifa etmesi veya ifa
      etmemesi nedeniyle sorumlu tutulamaz. Mücbir sebep; doğal afet, isyan, savaş,
      ohal veya sıkıyönetim ilanı, iç karışıklık, grev, lokavt, salgın hastalık,
      telekomünikasyon altyapısından kaynaklanan arızalar, elektrik kesintisi ve kötü
      hava koşulları da dâhil ve fakat bunlarla sınırlı olmamak kaydıyla CDI’ın kontrolü
      haricinde gerçekleşen ve hizmetin verilmesini engelleyen olaylar olarak
      yorumlanacaktır. Mücbir sebep süresince CDI edimleri askıya alınabilecektir.</span></p>

  <p class=MsoNormal style='margin-bottom:0cm;text-align:justify;text-justify:
    inter-ideograph'><span style='font-size:5.0pt;line-height:115%;font-family:
    "Times New Roman",serif;mso-fareast-font-family:"Times New Roman";color:black;
    mso-themecolor:text1'></span></p>

  <p class=MsoNormal style='margin-bottom:0cm;text-align:justify;text-justify:
    inter-ideograph'><b style='mso-bidi-font-weight:normal'><span style='font-size:
    10.0pt;line-height:115%;font-family:"Times New Roman",serif;mso-fareast-font-family:
    Calibri;color:black'>12. Marka ve Telif Haklarımız:</span></b></p>

  <p class=MsoNormal style='margin-bottom:0cm;text-align:justify;text-justify:
    inter-ideograph'><span style='font-size:10.0pt;line-height:115%;font-family:
    "Times New Roman",serif;mso-fareast-font-family:Calibri;color:black'>CDI</span><span style='font-size:10.0pt;line-height:115%;font-family:"Times New Roman",serif;
    mso-fareast-font-family:"Times New Roman";color:black;mso-themecolor:text1'>
      tarafından sunulan veya bundan sonra geliştirilecek sunulacak tüm uygulama,
      modül, yazılım, program vs görsel,dijital ve fiziksel varlık ve datalar
      münhasıran CDI’a aitir.<span style='mso-spacerun:yes'>  </span>CDI tarafından
      açıkça ve yazılı olarak verilmiş bir yetki olmaksızın, CDI ve CDI ait CARDATA,
      CDI hizmetleri, modül ve uygulamalar, görselleri, marka, model, amblem ve
      logoları, bilgileri, yazılımları, web sayfası veya mobil tasarım ve görselleri,
      telif haklarına kapsamında olan olmayan her türlü ürün ve varlığı 3.kişilerce
      kullanılamaz. <span style='mso-spacerun:yes'> </span>Hizmetten Faydalanan
      gerçek veya tüzel kişiler yalnızca uygulamayı/modülü sınırlı süre ve koşullarda
      kullanmaya imkanı kazanır. Uygulama ve hizmetlerin ücretli veya ücretsiz olarak
      kullanıma sunulması hiçbir şekilde uygulamanın, modülün, yazılım ve veri
      tabanının, görsellerin, tasarım veya isim ve bunlarla sınırlı olmaksızın sair
      hakların devredildiği şekilde yorumlanamaz.,</span></p>

  <p class=MsoNormal style='margin-bottom:0cm;text-align:justify;text-justify:
    inter-ideograph'><span style='font-size:5.0pt;line-height:115%;font-family:
    "Times New Roman",serif;mso-fareast-font-family:"Times New Roman";color:black;
    mso-themecolor:text1'></span></p>

  <p class=MsoNormal style='margin-bottom:0cm;text-align:justify;text-justify:
    inter-ideograph'><b style='mso-bidi-font-weight:normal'><span style='font-size:
    10.0pt;line-height:115%;font-family:"Times New Roman",serif;mso-fareast-font-family:
    Calibri;color:black'>13. Sorumluluğun Sınırlandırılması:</span></b></p>

  <p class=MsoNormal style='margin-bottom:0cm;text-align:justify;text-justify:
    inter-ideograph'><span style='font-size:10.0pt;line-height:115%;font-family:
    "Times New Roman",serif;mso-fareast-font-family:Calibri;color:black'>CDI,</span><span style='font-size:10.0pt;line-height:115%;font-family:"Times New Roman",serif;
    mso-fareast-font-family:"Times New Roman";color:black;mso-themecolor:text1'><span style='mso-spacerun:yes'> 
      </span><span style='mso-spacerun:yes'> </span>web
      sayfası, modül, uygulama ve dataları ile ileride geliştirilerek hizmete
      sunacağı sair uygulama ve ürünlerinde, link verilen veya alınan yerlerde çıkan referans
      fiyatlamalar ve sair bilgiler sadece öngörü/bilgilendirme/fikir verme amaçlı olmakla,
      tam bir kesinlik, doğruluk, güncellik veya buna ilişkin bir taahhüt
      içermemektedir. Belirtilen niteliği gereği</span><span style='font-size:10.0pt;
    line-height:115%;font-family:"Times New Roman",serif;mso-fareast-font-family:
    Calibri;color:black;mso-themecolor:text1'> </span><span style='font-size:10.0pt;
    line-height:115%;font-family:"Times New Roman",serif;mso-fareast-font-family:
    "Times New Roman";color:black;mso-themecolor:text1'>bu bilgilerin, sorgulama
      sonuçlarının ve diğer verilerin kullanılması gibi sebeplerle doğabilecek
      doğrudan ya da dolaylı hiçbir zarardan CDI sorumlu değildir.</span><span style='font-size:10.0pt;line-height:115%;font-family:"Times New Roman",serif;
    mso-fareast-font-family:"Times New Roman";color:#242F62'> </span><span style='font-size:10.0pt;line-height:115%;font-family:"Times New Roman",serif;
    mso-fareast-font-family:"Times New Roman";color:black;mso-themecolor:text1'>Aracını
      Değerinde Hemen Sat uygulamasından/sayfasından kendisiyle iletişime geçilmesini
      talep eden ziyaretçi/ kullanıcı ile üye firma veya kişi arasında iletişim
      bilgisi ve raporlama aktarımı dışında hiçbir fonksiyonu bulunmayan CDI’ın bu
      kişiler arasında gerçekleşecek ilişki, iş, işlem, eylem ve ticaretten dolayı
      herhangi bir taraf sıfatı, taahhüdü ve sorumluluğu bulunmadığını taraflar kabul
      beyan ve taahhüt eder.</span></p>

  <p class=MsoNormal style='margin-bottom:0cm;text-align:justify;text-justify:
    inter-ideograph'><span style='font-size:10.0pt;line-height:115%;font-family:
    "Times New Roman",serif;mso-fareast-font-family:"Times New Roman";color:black;
    mso-themecolor:text1'><span style='mso-spacerun:yes'> </span></span></p>

  <p class=MsoNormal style='margin-bottom:0cm;text-align:justify;text-justify:
    inter-ideograph'><b style='mso-bidi-font-weight:normal'><span style='font-size:
    10.0pt;line-height:115%;font-family:"Times New Roman",serif;mso-fareast-font-family:
    Calibri;color:black'>14. Yetki, Uygulanacak Hukuk ve Delil Sözleşmesi:</span></b></p>

  <p class=MsoNormal style='margin-bottom:0cm;text-align:justify;text-justify:
    inter-ideograph'><span style='font-size:10.0pt;line-height:115%;font-family:
    "Times New Roman",serif;mso-fareast-font-family:"Times New Roman";color:black;
    mso-themecolor:text1'>Kullanım Koşulları”ndan ve yapılması halinde </span><span style='font-size:10.0pt;line-height:115%;font-family:"Times New Roman",serif;
    mso-fareast-font-family:Calibri;color:black'>Sözleşme</span><span style='font-size:10.0pt;line-height:115%;font-family:"Times New Roman",serif;
    mso-fareast-font-family:"Times New Roman";color:black;mso-themecolor:text1'>/lerden
      kaynaklanacak ihtilaflarda İstanbul (Çağlayan) Mahkemeleri ve İcra Daireleri
      yetkili olup, Türk Hukuku’na tabidir. </span></p>

  <p class=MsoNormal style='margin-bottom:0cm;text-align:justify;text-justify:
    inter-ideograph'><span style='font-size:10.0pt;line-height:115%;font-family:
    "Times New Roman",serif;mso-fareast-font-family:"Times New Roman";color:black;
    mso-themecolor:text1'>Hizmetten Faydalananlar (üye, abone, ziyaretçi/kullanıcı
      ve her hangi bir şekilde internet sitemiz ziyaret eden,uygulama ve modüllerden kullanan
      tüm gerçek ve tüzel kişiler), her hangi bir ihtilaf halinde CDI’ın resmi defter
      ve ticari kayıtları ile<span style='mso-spacerun:yes'>  </span>veri tabanında,
      sunucularında tutulan e-arşiv kayıtlarının, elektronik bilgilerin, elektronik
      yazışmaların ve bilgisayar kayıtlarının, iş bu kullanım koşulları ve sözleşme
      hükümleri ile atıfta bulunulan sair dokümanların taraflar için bağlayıcı, kesin
      ve münhasır delil teşkil edeceğini ve bu maddenin 6100 sayılı Hukuk
      Muhakemeleri Kanunu’nun 193. maddesi anlamında delil sözleşmesi niteliğinde
      olduğunu kabul eder.</span></p>

  <p class=MsoNormal style='margin-bottom:0cm;text-align:justify;text-justify:
    inter-ideograph'><span style='font-size:10.0pt;line-height:115%;font-family:
    "Times New Roman",serif;mso-fareast-font-family:"Times New Roman";color:black;
    mso-themecolor:text1'><br>
      Her bir hizmet/ürüne ilişkin sözleşme hükümler ve onun ayrılmaz bir parçası
      olan işbu Kullanım Koşulları’nın belli hüküm veya hükümlerinin her hangi bir
      şekilde geçersizliğine karar verilmesi halinde kalan diğer hükümlerin geçerliliği
      koruyacak ve <span style='mso-spacerun:yes'> </span>yürürlükte kalmaya devam
      edecektir. </span></p>

  <p class=MsoNormal style='margin-bottom:0cm;text-align:justify;text-justify:
    inter-ideograph'><span style='font-size:10.0pt;line-height:115%;font-family:
    "Times New Roman",serif;mso-fareast-font-family:"Times New Roman";color:black;
    mso-themecolor:text1'><br>
      Taraflar’dan birinin Kullanım Koşulları’nda kendisine verilen herhangi bir
      hakkı kullanmaması ya da icra etmemesi, söz konusu haktan feragat ettiği
      anlamına gelmez, bu durum söz konusu hakkın daha sonra kullanılmasını ya da
      icra edilmesini engellemez.</span></p>

  <p class=MsoNormal style='margin-bottom:0cm;text-align:justify;text-justify:
    inter-ideograph'><b style='mso-bidi-font-weight:normal'><span style='font-size:
    10.0pt;line-height:115%;font-family:"Times New Roman",serif;mso-fareast-font-family:
    Calibri;color:black'></span></b></p>

  <p class=MsoNormal style='margin-bottom:0cm;text-align:justify;text-justify:
    inter-ideograph'><b style='mso-bidi-font-weight:normal'><span style='font-size:
    10.0pt;line-height:115%;font-family:"Times New Roman",serif;mso-fareast-font-family:
    Calibri;color:black'>7.</span></b><span style='font-size:10.0pt;line-height:
    115%;font-family:"Times New Roman",serif;mso-fareast-font-family:Calibri;
    color:black'> İşbu Kullanım Koşullarının ve ilgili sözleşme hükümlerinin
      herhangi birini veya tümünü kabul etmemeniz<span style='mso-spacerun:yes'> 
      </span>halinde, CDI’ın wep sitesi ve mobil uygumla mağazaları vasıtasıyla
      sunmuş olduğumuz hizmetlerden faydalanamazsınız.<b style='mso-bidi-font-weight:
    normal'><span style='mso-spacerun:yes'>  </span></b></span></p>

  <p class=MsoNormal style='margin-bottom:0cm;text-align:justify;text-justify:
    inter-ideograph'><span style='font-size:10.0pt;line-height:115%;font-family:
    "Times New Roman",serif;mso-fareast-font-family:"Times New Roman";color:black;
    mso-themecolor:text1'></span></p>

  <p class=MsoNormal style='text-align:justify;text-justify:inter-ideograph'><b
      style='mso-bidi-font-weight:normal'><span style='font-size:10.0pt;line-height:
    115%;font-family:"Times New Roman",serif'>16.Kullanım Koşullarını Kabul Beyanı:
      </span></b><span style='font-size:10.0pt;line-height:115%;font-family:"Times New Roman",serif'><span
        style='mso-spacerun:yes'> </span>Abone veya kayıt olarak, sitemizi, web tabanlı
      veya mobil uygulamalarımızı kullanarak, onaya tabi işlemlerde onay vererek veya
      doğrulama kodunu girerek CDI tarafından ilan edilmiş işbu Kullanım Koşulları’nı
      kabul, beyan ve taahhüt etmiş olursunuz.</span></p>

  <p class=MsoNormal style='text-align:justify;text-justify:inter-ideograph'><span
      style='font-size:10.0pt;line-height:115%;font-family:"Times New Roman",serif'></span></p>

  <p class=MsoNormal style='text-align:justify;text-justify:inter-ideograph'><span
      style='font-size:10.0pt;line-height:115%;font-family:"Times New Roman",serif'>Ek-1
      <span><a href="javascript:void(0)" class="privacy_policy" style='color:#0070C0'>Gizlilik
          Politikası</a></span></span></p>

</div>
<div id="protection_of_personal_data_modal" class="modal-wrapper" style="display: none">
  <h3>MÜŞTERİ KİŞİSEL VERİLERİNİN İŞLENMESİ HAKKINDA</h3>
  <div class="modal-body">
    <p class=MsoNormal align=center style='margin-bottom:0cm;text-align:center;
mso-layout-grid-align:none;text-autospace:none'><b><span style='font-family:
"Palatino Linotype",serif;mso-fareast-font-family:Calibri;mso-bidi-font-family:
Arial;color:black'>AYDINLATMA METNİ</span></b><b style='mso-bidi-font-weight:
normal'><span style='font-family:"Palatino Linotype",serif;mso-fareast-font-family:
Calibri;mso-bidi-font-family:Arial'></span></b></p>



    <p class=MsoNormal style='margin-bottom:0cm;text-align:justify;text-justify:
inter-ideograph;mso-layout-grid-align:none;text-autospace:none'><b><span style='font-family:"Palatino Linotype",serif;mso-fareast-font-family:Calibri;
mso-bidi-font-family:Arial;color:black'>1- Metin Hakkında:</span></b></p>

    <p class=MsoNormal style='margin-bottom:0cm;text-align:justify;text-justify:
inter-ideograph;line-height:normal;background:white'><span style='font-family:
"Times New Roman",serif;mso-fareast-font-family:Calibri;color:black'>CDI
        Otomotiv Bilgi Hizmetleri Anonim Şirketi – Car Data <span class=SpellE>Internatıonal</span>
        olarak (kısaca şirket olarak anılacaktır), 6698 sayılı Kişisel Verilerin
        Korunması Kanunu’nun (KVKK veya Kanun) “Veri Sorumlusunun Aydınlatma
        Yükümlülüğü” başlıklı 10. maddesi uyarınca; kişisel verilerin işlemesi, işlenen
        kişisel verilerinizin aktarılması, kişisel verilerinizin toplanma yöntemleri ve
        bunun hukuki sebepleri ile KVKK 11.maddesinde sayılan haklarınızla ilgili
        olarak sizi bilgilendirmek ve aydınlatmak için iş bu metni hazırlamış
        bulunuyoruz. Bu nedenle, onay öncesi iş bu aydınlatma metnimizi ve açık rıza
        onay formunu okumanızı önemle rica ederiz.</span></p>



    <p class=MsoNormal style='margin-bottom:0cm;text-align:justify;text-justify:
inter-ideograph;line-height:normal;background:white'><b style='mso-bidi-font-weight:
normal'><span style='font-family:"Times New Roman",serif;mso-fareast-font-family:
Calibri;color:black'>Tanımlar:</span></b></p>

    <p class=MsoNormal style='margin-bottom:0cm;text-align:justify;text-justify:
inter-ideograph;line-height:normal;background:white'><span style='font-family:
"Times New Roman",serif;mso-fareast-font-family:Calibri;color:black'>6698 <span class=SpellE>sy</span> Kanun’un
        Kapsamı: Kişisel verileri işlenen gerçek
        kişiler ile bu verileri tamamen veya kısmen otomatik olan ya da herhangi bir
        veri kayıt sisteminin parçası olmak kaydıyla otomatik olmayan yollarla işleyen
        gerçek ve tüzel kişiler hakkında uygulanır.</span></p>

    <p class=MsoNormal style='margin-bottom:0cm;text-align:justify;text-justify:
inter-ideograph;line-height:normal;background:white'><span style='font-family:
"Times New Roman",serif;mso-fareast-font-family:Calibri;color:black'>Kişisel
        veri: Kimliği belirli veya belirlenebilir gerçek kişiye ilişkin her türlü
        bilgiyi</span></p>

    <p class=MsoNormal style='margin-bottom:0cm;text-align:justify;text-justify:
inter-ideograph;line-height:normal;background:white'><span style='font-family:
"Times New Roman",serif;mso-fareast-font-family:Calibri;color:black'>Açık rıza:
        Belirli bir konuya ilişkin, bilgilendirilmeye dayanan ve özgür iradeyle
        açıklanan rızayı,</span></p>

    <p class=MsoNormal style='margin-bottom:0cm;text-align:justify;text-justify:
inter-ideograph;line-height:normal;background:white'><span style='font-family:
"Times New Roman",serif;mso-fareast-font-family:Calibri;color:black'>Kişisel Verilerin
        İşlenmesi: Kişisel verilerin tamamen veya kısmen otomatik olan ya da herhangi
        bir veri kayıt sisteminin parçası olmak kaydıyla otomatik olmayan yollarla elde
        edilmesi, kaydedilmesi, depolanması, muhafaza edilmesi, değiştirilmesi, yeniden
        düzenlenmesi, açıklanması, aktarılması, devralınması, elde edilebilir hâle
        getirilmesi, sınıflandırılması ya da kullanılmasının engellenmesi gibi veriler
        üzerinde gerçekleştirilen her türlü işlemi</span></p>

    <p class=MsoNormal style='margin-bottom:0cm;text-align:justify;text-justify:
inter-ideograph;line-height:normal;background:white'><span style='font-family:
"Times New Roman",serif;mso-fareast-font-family:Calibri;color:black'>Veri
        sorumlusu: Kişisel verilerin işleme amaçlarını ve vasıtalarını belirleyen, veri
        kayıt sisteminin kurulmasından ve <span class=GramE>yönetilmesinden</span>
        sorumlu olan gerçek veya tüzel kişiyi,</span></p>

    <p class=MsoNormal style='margin-bottom:0cm;text-align:justify;text-justify:
inter-ideograph;line-height:normal;background:white'><span class=GramE><span style='font-family:"Times New Roman",serif;mso-fareast-font-family:Calibri;
color:black'>ifade</span></span><span style='font-family:"Times New Roman",serif;
mso-fareast-font-family:Calibri;color:black'> etmektedir.</span></p>



    <p class=MsoNormal style='margin-bottom:0cm;text-align:justify;text-justify:
inter-ideograph;line-height:normal;background:white'><b><span style='font-family:
"Palatino Linotype",serif;mso-fareast-font-family:Calibri;mso-bidi-font-family:
Arial;color:black'>2-Veri Sorumlusu:</span></b></p>

    <p class=MsoNormal style='margin-bottom:0cm;text-align:justify;text-justify:
inter-ideograph;line-height:normal;background:white'><span style='font-family:
"Times New Roman",serif;mso-fareast-font-family:Calibri;color:black'>CDI
        Otomotiv Bilgi Hizmetleri A.Ş. (Koşuyolu <span class=SpellE>Mh</span>. <span class=SpellE>Halili</span> <span
          class=SpellE>Sk</span>. No:9/2 34718 Kadıköy /
        İstanbul, Ticaret Sicil No: 828237, <span class=SpellE>Mersis</span> No: 0203031125400012)
        Veri Sorumlusu sıfatıyla, kişisel verilerinizi (Kişisel veri: Kimliği belirli
        veya belirlenebilir gerçek kişiye ilişkin her türlü bilgi demektir), hukuka ve
        dürüstlük kurallarına uygun olarak ve bu metinde belirtilen amaçlarla ve
        belirtilen şekillerde toplayabilecek, işleyebilecek, kaydedebilecek,
        saklayabilecek, sınıflandırabilecek, güncelleyebilecek ve mevzuatın izin
        verdiği hallerde veya işlendikleri amaçla sınırlı olarak bilgileri paylaşarak açıklayabilecek
        ve aktarabilecektir (Kişisel verilerin işlenmesi: Kişisel verilerin tamamen
        veya kısmen otomatik olan ya da herhangi bir veri kayıt sisteminin parçası
        olmak kaydıyla otomatik olmayan yollarla elde edilmesi, kaydedilmesi,
        depolanması, muhafaza edilmesi, değiştirilmesi, yeniden düzenlenmesi,
        açıklanması, aktarılması, devralınması, elde edilebilir hâle getirilmesi,
        sınıflandırılması ya da kullanılmasının engellenmesi gibi veriler üzerinde
        gerçekleştirilen her türlü işlem) </span></p>



    <p class=MsoNormal style='margin-bottom:0cm;text-align:justify;text-justify:
inter-ideograph;line-height:normal;background:white'><span style='font-family:
"Times New Roman",serif;mso-fareast-font-family:Calibri;color:black'>Bu
        çerçevede bize sağladığınız tüm kişisel verilerinizin gizliliği ve güvenliği
        konusunda azami özeni göstererek korunması ve güvenliği için gerekli tüm idari
        ve teknik tedbirleri aldığımızı bilmenizi isteriz. Bilgi/veri güvenliği
        standartları ve prosedürleri çerçevesinde korumak için gerekli tedbirlerin alınmış
        olmasıyla birlikte, web sitesine, uygulamaya veya sisteme yapılan saldırılar
        sonucunda kişisel verilerin zarar görmesi yahut üçüncü kişilerin eline geçmesi gibi
        durumlarda,&nbsp;bu husus derhal veri sahiplerine ve ayrıca Kişisel Verileri
        Koruma Kurulu’na bildirecektir.&nbsp;</span></p>



    <p class=MsoNormal style='margin-bottom:0cm;text-align:justify;text-justify:
inter-ideograph;line-height:normal;background:white'><span style='font-family:
"Times New Roman",serif;mso-fareast-font-family:Calibri;color:black'>Veri
        sorumlusu, kişisel verilerin işlenmesi,<b style='mso-bidi-font-weight:normal'> </b>veri
        işleyenler vasıtası ile de yerine <span class=SpellE>getirilebilinir</span>. (Veri
        işleyeni, veri sorumlusunun verdiği yetkiye dayanarak, onun adına kişisel
        verileri işleyen gerçek veya tüzel kişidir.)</span></p>



    <p class=MsoNormal style='margin-bottom:0cm;text-align:justify;text-justify:
inter-ideograph;line-height:normal;background:white'><b style='mso-bidi-font-weight:
normal'><span style='font-family:"Times New Roman",serif;mso-fareast-font-family:
Calibri;color:black'>3- Kişisel Verilerinizin Hangi Amaçla İşleneceği:</span></b></p>

    <p class=MsoNormal style='margin-bottom:0cm;text-align:justify;text-justify:
inter-ideograph;line-height:normal;background:white'><span style='font-family:
"Times New Roman",serif;mso-fareast-font-family:Calibri;color:black'>Kişisel
        verileriniz, sunduğumuz hizmetlerden yararlanabilmeniz amacıyla açık rızanıza ve
        KVKK. <span class=GramE>madde</span> 5/2’de öngörülen diğer işleme şartlarına
        bağlı olarak işlenmektedir. Biz ve hizmet sağlayıcılarımız, sunulan hizmetlerin
        gereği olarak kişisel verilerinizi toplayabilmektedir. Şirketimizin verdiği
        hizmetler kapsamında kişisel verilerinizin işlenme amaçları;</span></p>



    <p class=MsoListParagraphCxSpFirst style='margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:7.1pt;mso-add-space:auto;text-align:justify;
text-justify:inter-ideograph;text-indent:-7.1pt;line-height:normal;mso-list:
l0 level1 lfo6;background:white'><span style='font-family:
Symbol;mso-fareast-font-family:Symbol;mso-bidi-font-family:Symbol;color:black'><span style='mso-list:Ignore'>·<span
            style='font:7.0pt "Times New Roman"'> </span></span></span><span dir=LTR></span><span style='font-family:"Times New Roman",serif;mso-fareast-font-family:
Calibri;color:black'>E-bülten, ürün ve uygulamalarımızı veya <span class=SpellE>demolarını</span> kullanabilmeniz,
        üyelik işlemlerinin
        yapılabilmesi, telefonunuza veya <span class=GramE>mail</span> adresinize doğrulama
        kodu veya şifre gönderilebilmesi/teslimi, doğrulama kodu/şifre kullanarak uygulamalarımıza
        erişim sağlayabilmeniz, böylece sizi tanıyabilmemiz ve hizmeti sunabilmemiz ile
        gerekli durumlarda sizinle iletişime geçilebilmesi,</span></p>

    <p class=MsoListParagraphCxSpMiddle style='margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:7.1pt;mso-add-space:auto;text-align:justify;
text-justify:inter-ideograph;text-indent:-7.1pt;line-height:normal;mso-list:
l0 level1 lfo6;background:white'><span style='font-family:
Symbol;mso-fareast-font-family:Symbol;mso-bidi-font-family:Symbol;color:black'><span style='mso-list:Ignore'>·<span
            style='font:7.0pt "Times New Roman"'> </span></span></span><span dir=LTR></span><span style='font-family:"Times New Roman",serif;mso-fareast-font-family:
Calibri;color:black'>2.el araç fiyatlandırması içerikli web tabanlı, <span class=SpellE>android</span> ve <span
          class=SpellE>app</span> uygulamalarında, başlangıçta
        referans fiyatlaması için aracınıza ait bilgi ve özelliklerin bilinmesi (marka,
        model, model yılı, km, hasar, plaka <span class=SpellE><span class=GramE>vs</span></span><span class=GramE><span
            style='mso-spacerun:yes'>  </span>gibi</span>)</span></p>

    <p class=MsoListParagraphCxSpMiddle style='margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:7.1pt;mso-add-space:auto;text-align:justify;
text-justify:inter-ideograph;text-indent:-7.1pt;line-height:normal;mso-list:
l0 level1 lfo6;background:white'><span style='font-family:
Symbol;mso-fareast-font-family:Symbol;mso-bidi-font-family:Symbol;color:black'><span style='mso-list:Ignore'>·<span
            style='font:7.0pt "Times New Roman"'> </span></span></span><span dir=LTR></span><span style='font-family:"Times New Roman",serif;mso-fareast-font-family:
Calibri;color:black'>Üyelik, müşteri ve e-bülten abonelik kayıtlarınızın oluşturulması
        ile ilişkilerin yönetilmesi ve iyileştirilmesi, gerçekleşmesi halinde ticari
        ilişkiye ilişkin süreçlerin yürütülmesi,</span></p>

    <p class=MsoListParagraphCxSpMiddle style='margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:7.1pt;mso-add-space:auto;text-align:justify;
text-justify:inter-ideograph;text-indent:-7.1pt;line-height:normal;mso-list:
l0 level1 lfo6;background:white'><span style='font-family:
Symbol;mso-fareast-font-family:Symbol;mso-bidi-font-family:Symbol;color:black'><span style='mso-list:Ignore'>·<span
            style='font:7.0pt "Times New Roman"'> </span></span></span><span dir=LTR></span><span style='font-family:"Times New Roman",serif;mso-fareast-font-family:
Calibri;color:black'>İş süreçlerimizin yürütülebilmesi için sizinle iletişime
        geçilebilmesi,</span></p>

    <p class=MsoListParagraphCxSpMiddle style='margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:7.1pt;mso-add-space:auto;text-align:justify;
text-justify:inter-ideograph;text-indent:-7.1pt;line-height:normal;mso-list:
l0 level1 lfo6;background:white'><span style='font-family:
Symbol;mso-fareast-font-family:Symbol;mso-bidi-font-family:Symbol;color:black'><span style='mso-list:Ignore'>·<span
            style='font:7.0pt "Times New Roman"'> </span></span></span><span dir=LTR></span><span style='font-family:"Times New Roman",serif;mso-fareast-font-family:
Calibri;color:black'>Çevrimiçi platformlarımıza kayıt ve giriş yapılabilmesi,</span></p>

    <p class=MsoListParagraphCxSpMiddle style='margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:7.1pt;mso-add-space:auto;text-align:justify;
text-justify:inter-ideograph;text-indent:-7.1pt;line-height:normal;mso-list:
l0 level1 lfo6;background:white'><span style='font-family:
Symbol;mso-fareast-font-family:Symbol;mso-bidi-font-family:Symbol'><span style='mso-list:Ignore'>·<span
            style='font:7.0pt "Times New Roman"'> </span></span></span><span dir=LTR></span><span style='font-family:"Times New Roman",serif;mso-fareast-font-family:
Calibri;color:black;mso-color-alt:windowtext'>İş faaliyetlerimiz ile ilgili
        e-posta/SMS gönderilebilmesi,</span><span style='font-family:"Times New Roman",serif;
mso-fareast-font-family:Calibri'></span></p>

    <p class=MsoListParagraphCxSpMiddle style='margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:7.1pt;mso-add-space:auto;text-align:justify;
text-justify:inter-ideograph;text-indent:-7.1pt;line-height:normal;mso-list:
l0 level1 lfo6;background:white'><span style='font-family:
Symbol;mso-fareast-font-family:Symbol;mso-bidi-font-family:Symbol'><span style='mso-list:Ignore'>·<span
            style='font:7.0pt "Times New Roman"'> </span></span></span><span dir=LTR></span><span style='font-family:"Times New Roman",serif;mso-fareast-font-family:
Calibri;color:black;mso-color-alt:windowtext'>Ücretli ürünlerde fatura
        düzenlenmesi, ödemelerin gerçekleştirilmesi ve kaydedilmesi dahil tüm finansal
        ve <span class=SpellE>muhasebesel</span> süreçlerin yürütülmesi,</span><span
        style='font-family:"Times New Roman",serif;mso-fareast-font-family:Calibri'></span></p>

    <p class=MsoListParagraphCxSpMiddle style='margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:7.1pt;mso-add-space:auto;text-align:justify;
text-justify:inter-ideograph;text-indent:-7.1pt;line-height:normal;mso-list:
l0 level1 lfo6;background:white'><span style='font-family:
Symbol;mso-fareast-font-family:Symbol;mso-bidi-font-family:Symbol'><span style='mso-list:Ignore'>·<span
            style='font:7.0pt "Times New Roman"'> </span></span></span><span dir=LTR></span><span style='font-family:"Times New Roman",serif;mso-fareast-font-family:
Calibri;color:black;mso-color-alt:windowtext'>Ürün veya hizmetlerimiz hakkında
        talep ve şikayetlerinizin takibi,</span><span style='font-family:"Times New Roman",serif;
mso-fareast-font-family:Calibri'></span></p>

    <p class=MsoListParagraphCxSpMiddle style='margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:7.1pt;mso-add-space:auto;text-align:justify;
text-justify:inter-ideograph;text-indent:-7.1pt;line-height:normal;mso-list:
l0 level1 lfo6;background:white'><span style='font-family:
Symbol;mso-fareast-font-family:Symbol;mso-bidi-font-family:Symbol'><span style='mso-list:Ignore'>·<span
            style='font:7.0pt "Times New Roman"'> </span></span></span><span dir=LTR></span><span style='font-family:"Times New Roman",serif;mso-fareast-font-family:
Calibri;color:black;mso-color-alt:windowtext'>Bilgilerinizin, doğabilecek
        uyuşmazlıklarda delil olarak kullanılması,</span><span style='font-family:"Times New Roman",serif;
mso-fareast-font-family:Calibri'></span></p>

    <p class=MsoListParagraphCxSpMiddle style='margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:7.1pt;mso-add-space:auto;text-align:justify;
text-justify:inter-ideograph;text-indent:-7.1pt;line-height:normal;mso-list:
l0 level1 lfo6;background:white'><span style='font-family:
Symbol;mso-fareast-font-family:Symbol;mso-bidi-font-family:Symbol;color:black'><span style='mso-list:Ignore'>·<span
            style='font:7.0pt "Times New Roman"'> </span></span></span><span dir=LTR></span><span style='font-family:"Times New Roman",serif;mso-fareast-font-family:
Calibri;color:black'>Şirketin <span class=SpellE>operasyonel</span>
        süreçlerinin yürütülmesi,</span></p>

    <p class=MsoListParagraphCxSpMiddle style='margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:7.1pt;mso-add-space:auto;text-align:justify;
text-justify:inter-ideograph;text-indent:-7.1pt;line-height:normal;mso-list:
l0 level1 lfo6;background:white'><span style='font-family:
Symbol;mso-fareast-font-family:Symbol;mso-bidi-font-family:Symbol;color:black'><span style='mso-list:Ignore'>·<span
            style='font:7.0pt "Times New Roman"'> </span></span></span><span dir=LTR></span><span style='font-family:"Times New Roman",serif;mso-fareast-font-family:
Calibri;color:black'>Saklama ve arşiv faaliyetlerinin yürütülmesi,</span></p>

    <p class=MsoListParagraphCxSpMiddle style='margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:7.1pt;mso-add-space:auto;text-align:justify;
text-justify:inter-ideograph;text-indent:-7.1pt;line-height:normal;mso-list:
l0 level1 lfo6;background:white'><span style='font-family:
Symbol;mso-fareast-font-family:Symbol;mso-bidi-font-family:Symbol;color:black'><span style='mso-list:Ignore'>·<span
            style='font:7.0pt "Times New Roman"'> </span></span></span><span dir=LTR></span><span style='font-family:"Times New Roman",serif;mso-fareast-font-family:
Calibri;color:black'>Bilgi güvenliği süreçlerinin yürütülmesi,</span></p>

    <p class=MsoListParagraphCxSpMiddle style='margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:7.1pt;mso-add-space:auto;text-align:justify;
text-justify:inter-ideograph;text-indent:-7.1pt;line-height:normal;mso-list:
l0 level1 lfo6;background:white'><span style='font-family:
Symbol;mso-fareast-font-family:Symbol;mso-bidi-font-family:Symbol;color:black'><span style='mso-list:Ignore'>·<span
            style='font:7.0pt "Times New Roman"'> </span></span></span><span dir=LTR></span><span style='font-family:"Times New Roman",serif;mso-fareast-font-family:
Calibri;color:black'>Yasal uyumluluğa ilişkin süreçlerin yürütülebilmesi,</span></p>

    <p class=MsoListParagraphCxSpMiddle style='margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:7.1pt;mso-add-space:auto;text-align:justify;
text-justify:inter-ideograph;text-indent:-7.1pt;line-height:normal;mso-list:
l0 level1 lfo6;background:white'><span style='font-family:
Symbol;mso-fareast-font-family:Symbol;mso-bidi-font-family:Symbol;color:black'><span style='mso-list:Ignore'>·<span
            style='font:7.0pt "Times New Roman"'> </span></span></span><span dir=LTR></span><span style='font-family:"Times New Roman",serif;mso-fareast-font-family:
Calibri;color:black'>Yetkili kurum ve kuruluşlara bilgi verilmesi,</span></p>

    <p class=MsoListParagraphCxSpMiddle style='margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:7.1pt;mso-add-space:auto;text-align:justify;
text-justify:inter-ideograph;text-indent:-7.1pt;line-height:normal;mso-list:
l0 level1 lfo6;background:white'><span style='font-family:
Symbol;mso-fareast-font-family:Symbol;mso-bidi-font-family:Symbol;color:black'><span style='mso-list:Ignore'>·<span
            style='font:7.0pt "Times New Roman"'> </span></span></span><span dir=LTR></span><span style='font-family:"Times New Roman",serif;mso-fareast-font-family:
Calibri;color:black'>İş süreçlerimizin devamlılığının sağlanması,</span></p>

    <p class=MsoListParagraphCxSpMiddle style='margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:7.1pt;mso-add-space:auto;text-align:justify;
text-justify:inter-ideograph;text-indent:-7.1pt;line-height:normal;mso-list:
l0 level1 lfo6;background:white'><span style='font-family:
Symbol;mso-fareast-font-family:Symbol;mso-bidi-font-family:Symbol;color:black'><span style='mso-list:Ignore'>·<span
            style='font:7.0pt "Times New Roman"'> </span></span></span><span dir=LTR></span><span style='font-family:"Times New Roman",serif;mso-fareast-font-family:
Calibri;color:black'>İlgili yasalarda belirlenen belgelerin düzenlenmesi,
        saklanma süresi, bildirim gibi hukuki yükümlülüklerimizi yerine getirmek.</span></p>

    <p class=MsoListParagraphCxSpMiddle style='margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:7.1pt;mso-add-space:auto;text-align:justify;
text-justify:inter-ideograph;text-indent:-7.1pt;line-height:normal;mso-list:
l0 level1 lfo6;background:white'><span style='font-family:
Symbol;mso-fareast-font-family:Symbol;mso-bidi-font-family:Symbol;color:black;
mso-themecolor:text1'><span style='mso-list:Ignore'>·<span style='font:7.0pt "Times New Roman"'>
          </span></span></span><span dir=LTR></span><span style='font-family:
"Times New Roman",serif;mso-fareast-font-family:Calibri;color:black'>Pazarlama
        amaçları ile müşterilerin memnuniyetlerini ölçebilmek için anket yapılması,
        ürün ve hizmetlerimizin tercihi, kullanım alışkanlığı ve beğenilerinize göre
        özelleştirilebilmesi, ürün ve </span><span style='font-family:"Times New Roman",serif;
mso-fareast-font-family:Calibri;color:black;mso-themecolor:text1'>hizmetlerimizin
        geliştirilmesi, </span><span style='font-family:"Times New Roman",serif;
mso-fareast-font-family:"Times New Roman";color:black;mso-themecolor:text1'>pazar
        araştırması ve analizinin yürütülmesi,</span><span style='font-family:"Times New Roman",serif;
mso-fareast-font-family:Calibri;color:black;mso-themecolor:text1'></span></p>

    <p class=MsoListParagraphCxSpMiddle style='margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:7.1pt;mso-add-space:auto;text-align:justify;
text-justify:inter-ideograph;text-indent:-7.1pt;line-height:normal;mso-list:
l0 level1 lfo6;background:white'><span style='font-family:
Symbol;mso-fareast-font-family:Symbol;mso-bidi-font-family:Symbol;color:black;
mso-themecolor:text1'><span style='mso-list:Ignore'>·<span style='font:7.0pt "Times New Roman"'>
          </span></span></span><span dir=LTR></span><span style='font-family:
"Times New Roman",serif;mso-fareast-font-family:Calibri;color:black;mso-themecolor:
text1'>Uygulamalarımıza ilişkin onay, talep veya ürün satın almaya yönelik talebinizin/onayınızın
        karşılanabilmesi,</span></p>

    <p class=MsoListParagraphCxSpLast style='margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:7.1pt;mso-add-space:auto;text-align:justify;
text-justify:inter-ideograph;text-indent:-7.1pt;line-height:normal;mso-list:
l0 level1 lfo6;background:white'><span style='font-family:
Symbol;mso-fareast-font-family:Symbol;mso-bidi-font-family:Symbol;color:black;
mso-themecolor:text1'><span style='mso-list:Ignore'>·<span style='font:7.0pt "Times New Roman"'>
          </span></span></span><span dir=LTR></span><span style='font-family:
"Times New Roman",serif;mso-fareast-font-family:Calibri;color:black;mso-themecolor:
text1'><span style='mso-spacerun:yes'> </span>Alış veya satış kampanyaları,
        e-bülten, ürünler, tanıtım ve fırsatlar hakkında SMS, <span class=GramE>mail</span>,
        <span class=SpellE>WhatsApp</span>, çağrı merkezi vs. yollarla tarafınıza bilgilendirme
        veya arama yapılabilmesi, ileti gönderilebilmesi, reklam,</span></p>

    <p class=MsoNoSpacing style='margin-left:7.1pt;text-align:justify;text-justify:
inter-ideograph;text-indent:-7.1pt;mso-list:l0 level1 lfo6'><span style='font-family:Symbol;mso-fareast-font-family:Symbol;mso-bidi-font-family:
Symbol'><span style='mso-list:Ignore'>·<span style='font:7.0pt "Times New Roman"'>
          </span></span></span><span dir=LTR></span><span style='font-family:
"Times New Roman",serif;mso-fareast-font-family:"Times New Roman";color:black;
mso-themecolor:text1'>Şirket’imiz tarafından sunulan ürün ve hizmetlerden
        Müşterilerimizi faydalandırmak için gerekli çalışmaların iş birimlerimiz</span><span
        style='font-family:"Times New Roman",serif;mso-fareast-font-family:"Times New Roman"'>
        ve/veya ortaklarımız tarafından yapılması,</span></p>

    <p class=MsoNoSpacing style='margin-left:7.1pt;text-align:justify;text-justify:
inter-ideograph;text-indent:-7.1pt;mso-list:l0 level1 lfo6'><span style='font-family:Symbol;mso-fareast-font-family:Symbol;mso-bidi-font-family:
Symbol'><span style='mso-list:Ignore'>·<span style='font:7.0pt "Times New Roman"'>
          </span></span></span><span dir=LTR></span><span style='font-family:
"Times New Roman",serif;mso-fareast-font-family:"Times New Roman"'>Müşteriler
        ile ilgili olarak yasal sınırlar içerisinde değerlendirme, analiz ve risk
        yönetim çalışmalarının yapılması,</span><span style='font-size:10.5pt;
font-family:"Times New Roman",serif;mso-fareast-font-family:"Times New Roman"'>
      </span><span style='font-family:"Times New Roman",serif;mso-fareast-font-family:
"Times New Roman"'></span></p>

    <p class=MsoNoSpacing style='margin-left:7.1pt;text-align:justify;text-justify:
inter-ideograph;text-indent:-7.1pt;mso-list:l0 level1 lfo6'><span style='font-family:Symbol;mso-fareast-font-family:Symbol;mso-bidi-font-family:
Symbol'><span style='mso-list:Ignore'>·<span style='font:7.0pt "Times New Roman"'>
          </span></span></span><span dir=LTR></span><span style='font-family:
"Times New Roman",serif;mso-fareast-font-family:"Times New Roman"'>Hizmet
        şartlarımızda ve elektronik hizmetlerimizde meydana gelebilecek değişiklikler
        hakkında bilgilendirme yapılması,</span></p>

    <p class=MsoNoSpacing style='margin-left:7.1pt;text-align:justify;text-justify:
inter-ideograph;text-indent:-7.1pt;mso-list:l0 level1 lfo6'><span style='font-family:Symbol;mso-fareast-font-family:Symbol;mso-bidi-font-family:
Symbol'><span style='mso-list:Ignore'>·<span style='font:7.0pt "Times New Roman"'>
          </span></span></span><span dir=LTR></span><span style='font-family:
"Times New Roman",serif;mso-fareast-font-family:"Times New Roman"'>Talep ve
        kabule göre araç taliplisi 3.kişilerin sizinle iletişime geçebilmesi için
        iletişim bilgilerinizin paylaşabilmesi (şirkete ait aracını değerinde Hemen Sat
        uygulaması sadece araç satıcıları ile alıcılarının iletişime geçebilmelerini
        sağmaya yönelik bir platform olup, Şirket hiçbir şekilde bu kişiler arasında
        gerçekleşecek ticaretin bir parçası, paydaşı, tarafı veya garantörü değildir ve
        iletişim verileriniz talebiniz üzerine aktarılmakla/<span class=SpellE>payalaşılmakla</span>
        bundan sonrasına ilişkin her hangi bir taahhüdümüz ve sorumluluğumuz bulunmamaktadır)</span></p>

    <p class=MsoNoSpacing style='margin-left:7.1pt;text-align:justify;text-justify:
inter-ideograph;text-indent:-7.1pt;mso-list:l0 level1 lfo6'><span style='font-family:Symbol;mso-fareast-font-family:Symbol;mso-bidi-font-family:
Symbol'><span style='mso-list:Ignore'>·<span style='font:7.0pt "Times New Roman"'>
          </span></span></span><span dir=LTR></span><span style='font-family:
"Times New Roman",serif;mso-fareast-font-family:"Times New Roman"'>Şirket'imiz
        ve iş ilişkisi içerisinde olduğu kişilerin hukuki ve ticari güvenliğinin
        temini,</span></p>

    <p class=MsoNoSpacing style='margin-left:7.1pt;text-align:justify;text-justify:
inter-ideograph;text-indent:-7.1pt;mso-list:l0 level1 lfo6'><span style='font-family:Symbol;mso-fareast-font-family:Symbol;mso-bidi-font-family:
Symbol'><span style='mso-list:Ignore'>·<span style='font:7.0pt "Times New Roman"'>
          </span></span></span><span dir=LTR></span><span style='font-family:
"Times New Roman",serif;mso-fareast-font-family:"Times New Roman"'>İş
        ortaklarımız, çalışmış olduğumuz ürün/uygulama alıcıları, otomotiv üretici, distribütör
        veya ikinci el firmaları, iş ilişkisi içinde olduğumuz kurumlar ve
        tedarikçilerle yürütülen işlerin planlanması,</span></p>

    <p class=MsoNoSpacing style='margin-left:7.1pt;text-align:justify;text-justify:
inter-ideograph;text-indent:-7.1pt;mso-list:l0 level1 lfo6'><span style='font-family:Symbol;mso-fareast-font-family:Symbol;mso-bidi-font-family:
Symbol'><span style='mso-list:Ignore'>·<span style='font:7.0pt "Times New Roman"'>
          </span></span></span><span dir=LTR></span><span style='font-family:
"Times New Roman",serif;mso-fareast-font-family:"Times New Roman"'>Şirket’imizin
        ticari ve iş ile ilgili stratejilerinin belirlenmesi ve uygulanması,</span></p>

    <p class=MsoNoSpacing style='margin-left:7.1pt;text-align:justify;text-justify:
inter-ideograph;text-indent:-7.1pt;mso-list:l0 level1 lfo6'><span style='font-family:Symbol;mso-fareast-font-family:Symbol;mso-bidi-font-family:
Symbol'><span style='mso-list:Ignore'>·<span style='font:7.0pt "Times New Roman"'>
          </span></span></span><span dir=LTR></span><span style='font-family:
"Times New Roman",serif;mso-fareast-font-family:"Times New Roman"'>Müşteri şikayetlerinin
        çözülmesi ve veri erişim veya düzeltme taleplerinin işleme alınması,</span></p>

    <p class=MsoNoSpacing style='margin-left:7.1pt;text-align:justify;text-justify:
inter-ideograph;text-indent:-7.1pt;mso-list:l0 level1 lfo6'><span style='font-family:Symbol;mso-fareast-font-family:Symbol;mso-bidi-font-family:
Symbol'><span style='mso-list:Ignore'>·<span style='font:7.0pt "Times New Roman"'>
          </span></span></span><span dir=LTR></span><span style='font-family:
"Times New Roman",serif;mso-fareast-font-family:"Times New Roman"'>Müşteri
        bazlı gelişmeler hakkında bilgi alınarak verim raporlarının oluşturulması ve
        güncellenmesi,</span></p>

    <p class=MsoNoSpacing style='margin-left:7.1pt;text-align:justify;text-justify:
inter-ideograph;text-indent:-7.1pt;mso-list:l0 level1 lfo6'><span style='font-family:Symbol;mso-fareast-font-family:Symbol;mso-bidi-font-family:
Symbol'><span style='mso-list:Ignore'>·<span style='font:7.0pt "Times New Roman"'>
          </span></span></span><span dir=LTR></span><span style='font-family:
"Times New Roman",serif;mso-fareast-font-family:"Times New Roman"'>Ürün ve/veya
        hizmetlerimiz için anlaşmaların takibi, planlanması ve yürütülmesi,</span></p>

    <p class=MsoNoSpacing style='margin-left:7.1pt;text-align:justify;text-justify:
inter-ideograph;text-indent:-7.1pt;mso-list:l0 level1 lfo6'><span style='font-family:Symbol;mso-fareast-font-family:Symbol;mso-bidi-font-family:
Symbol'><span style='mso-list:Ignore'>·<span style='font:7.0pt "Times New Roman"'>
          </span></span></span><span dir=LTR></span><span style='font-family:
"Times New Roman",serif;mso-fareast-font-family:"Times New Roman"'>Sosyal medya
        paylaşım fonksiyonunun kolaylaştırılması,</span></p>

    <p class=MsoNoSpacing style='margin-left:7.1pt;text-align:justify;text-justify:
inter-ideograph;text-indent:-7.1pt;mso-list:l0 level1 lfo6'><span style='font-family:Symbol;mso-fareast-font-family:Symbol;mso-bidi-font-family:
Symbol'><span style='mso-list:Ignore'>·<span style='font:7.0pt "Times New Roman"'>
          </span></span></span><span dir=LTR></span><span style='font-family:
"Times New Roman",serif;mso-fareast-font-family:"Times New Roman"'>Müşteriye
        özel satış ve pazarlama faaliyetlerinin planlanması ve gerçekleştirilmesi,</span></p>

    <p class=MsoNoSpacing style='margin-left:7.1pt;text-align:justify;text-justify:
inter-ideograph;text-indent:-7.1pt;mso-list:l0 level1 lfo6'><span style='font-family:Symbol;mso-fareast-font-family:Symbol;mso-bidi-font-family:
Symbol'><span style='mso-list:Ignore'>·<span style='font:7.0pt "Times New Roman"'>
          </span></span></span><span dir=LTR></span><span style='font-family:
"Times New Roman",serif;mso-fareast-font-family:"Times New Roman"'>Hukuki
        süreçlerin ve <span class=GramE>resmi</span> kurumlarla iletişim süreçlerinin
        takibi ve icrası,</span></p>

    <p class=MsoNoSpacing style='margin-left:7.1pt;text-align:justify;text-justify:
inter-ideograph;text-indent:-7.1pt;mso-list:l0 level1 lfo6'><span style='font-family:Symbol;mso-fareast-font-family:Symbol;mso-bidi-font-family:
Symbol'><span style='mso-list:Ignore'>·<span style='font:7.0pt "Times New Roman"'>
          </span></span></span><span dir=LTR></span><span style='font-family:
"Times New Roman",serif;mso-fareast-font-family:"Times New Roman"'>Bilgi
        güvenliği süreçlerinin planlanması, bilgi teknolojileri alt yapısının oluşturulması
        ve yönetilmesi,</span></p>

    <p class=MsoNoSpacing style='margin-left:7.1pt;text-align:justify;text-justify:
inter-ideograph;text-indent:-7.1pt;mso-list:l0 level1 lfo6'><span style='font-family:Symbol;mso-fareast-font-family:Symbol;mso-bidi-font-family:
Symbol'><span style='mso-list:Ignore'>·<span style='font:7.0pt "Times New Roman"'>
          </span></span></span><span dir=LTR></span><span style='font-family:
"Times New Roman",serif;mso-fareast-font-family:"Times New Roman"'>Risk
        yönetiminin yapılması, iş sürekliliğinin sağlanması, sözleşme süreçlerinin veya
        hukuki taleplerin takibi,</span></p>

    <p class=MsoNoSpacing style='margin-left:7.1pt;text-align:justify;text-justify:
inter-ideograph;text-indent:-7.1pt;mso-list:l0 level1 lfo6'><span style='font-family:Symbol;mso-fareast-font-family:Symbol;mso-bidi-font-family:
Symbol'><span style='mso-list:Ignore'>·<span style='font:7.0pt "Times New Roman"'>
          </span></span></span><span dir=LTR></span><span style='font-family:
"Times New Roman",serif;mso-fareast-font-family:"Times New Roman"'>İş ve
        operasyonların sürdürülmesi, Şirket faaliyetlerinin ve prosedürlerinin
        yürütülebilmesi,</span></p>

    <p class=MsoNoSpacing style='margin-left:7.1pt;text-align:justify;text-justify:
inter-ideograph;text-indent:-7.1pt;mso-list:l0 level1 lfo6'><span style='font-family:Symbol;mso-fareast-font-family:Symbol;mso-bidi-font-family:
Symbol'><span style='mso-list:Ignore'>·<span style='font:7.0pt "Times New Roman"'>
          </span></span></span><span dir=LTR></span><span style='font-family:
"Times New Roman",serif;mso-fareast-font-family:"Times New Roman"'>Müşteri
        ilişkilerinin yürütülmesi ve kurumsal yönetim faaliyetlerinin takibi,</span></p>

    <p class=MsoNoSpacing style='margin-left:7.1pt;text-align:justify;text-justify:
inter-ideograph;text-indent:-7.1pt;mso-list:l0 level1 lfo6'><span style='font-family:Symbol;mso-fareast-font-family:Symbol;mso-bidi-font-family:
Symbol'><span style='mso-list:Ignore'>·<span style='font:7.0pt "Times New Roman"'>
          </span></span></span><span dir=LTR></span><span style='font-family:
"Times New Roman",serif;mso-fareast-font-family:"Times New Roman"'>Düzenleyici
        ve denetleyici kurumlar ile resmi mercilerin talep ve denetimleri doğrultusunda
        ve aynı zamanda ilgili başvuruları inceleyecek mercilerden gerekli bilgi ve
        onayların temini,&nbsp;</span></p>

    <p class=MsoNoSpacing style='margin-left:7.1pt;text-align:justify;text-justify:
inter-ideograph;text-indent:-7.1pt;mso-list:l0 level1 lfo6'><span style='font-family:Symbol;mso-fareast-font-family:Symbol;mso-bidi-font-family:
Symbol'><span style='mso-list:Ignore'>·<span style='font:7.0pt "Times New Roman"'>
          </span></span></span><span dir=LTR></span><span style='font-family:
"Times New Roman",serif;mso-fareast-font-family:"Times New Roman"'>Yasal hakları
        belirlemek ve bunları savunmak; faaliyetlerimizi veya iş ortaklarımızın
        faaliyetlerini, haklarımızı, gizliliğimizi, güvenliğimizi veya malımızı ve/veya
        sizin veya başkalarının bu sayılan varlıklarının korunması ve kullanılabilir
        çarelerin uygulanması veya olası zararların sınırlandırılması,</span></p>

    <p class=MsoNoSpacing style='margin-left:7.1pt;text-align:justify;text-justify:
inter-ideograph;text-indent:-7.1pt;mso-list:l0 level1 lfo6'><span style='font-family:Symbol;mso-fareast-font-family:Symbol;mso-bidi-font-family:
Symbol'><span style='mso-list:Ignore'>·<span style='font:7.0pt "Times New Roman"'>
          </span></span></span><span dir=LTR></span><span style='font-family:
"Times New Roman",serif;mso-fareast-font-family:"Times New Roman"'>Pazar
        araştırmalarının yapılması, ürün ve hizmetlere bağlılığının sağlanması ve/veya
        artırılmasına yönelik aktivitelerin planlanması ve düzenlenmesi gibi amaçlarla <span
          class=SpellE>KVKK’nın</span> 5. ve 6. maddelerinde belirtilen kişisel veri işleme
        şartları ve amaçları dahilinde işlenebilecektir.</span><span style='mso-fareast-font-family:
"Times New Roman"'></span></p>



    <p class=MsoNormal style='margin-bottom:0cm;text-align:justify;text-justify:
inter-ideograph;line-height:normal;background:white'><span style='font-family:
"Times New Roman",serif;mso-fareast-font-family:Calibri;color:black'>Kişisel
        verileriniz, ilgili mevzuatta belirtilen veya işlendikleri amaç için gerekli
        olan azami süre ve her halde kanuni zamanaşımı süreleri kadar muhafaza
        edilecektir. </span></p>



    <p class=MsoNormal style='margin-bottom:0cm;text-align:justify;text-justify:
inter-ideograph;line-height:normal;background:white'><b style='mso-bidi-font-weight:
normal'><span style='font-family:"Times New Roman",serif;mso-fareast-font-family:
Calibri;color:black'>4- Hangi Kişisel Verilerin İşleneceği:</span></b></p>

    <p class=MsoNormal style='margin-bottom:0cm;text-align:justify;text-justify:
inter-ideograph;line-height:normal;background:white'><span style='font-family:
"Times New Roman",serif;mso-fareast-font-family:Calibri;color:black'>İletişim
        Verileri; Sizinle iletişim kurabilmek, ürün hizmet ve uygulamalarımızın
        kullanımı ve tedariki için şirket unvanı, ad, <span class=SpellE>soyad</span>,
        e-posta adresi ve telefon numaranız (Uygulama ve ürünlerde SMS İle Doğrulama
        İşlemi Google <span class=SpellE>Firebase</span> Tarafından Sağlanmaktadır,
        Bilgileriniz Doğrulama Amaçlı Kullanılmaktadır) vereceğiniz aracınıza ait
        marka,<span style='mso-spacerun:yes'>  </span>model, model yılı, hasar
        bilgileri, km, yakıt tip, plaka, <span class=SpellE>tramer</span> bilgisi vs. </span><span style='font-family:"Times New Roman",serif;mso-fareast-font-family:Calibri;
color:black;mso-themecolor:text1'>bilgileriniz ile sizinle iletişime geçilmesi,
        <span class=SpellE>demo</span> talebi, e-bülten aboneliği veya uygulama/ürün
        satın alma işlemlerinde veya aracınızın araç tedarikçileri tarafından satın
        alınmasını istemeniz halinde vereceğiniz sair her türlü adresleriniz, <span class=SpellE>lokasyon</span> ve
        iletişim bilgileriniz işlenecektir.</span></p>



    <p class=MsoNormal style='margin-bottom:0cm;text-align:justify;text-justify:
inter-ideograph;line-height:normal;background:white'><span style='font-family:
"Times New Roman",serif;mso-fareast-font-family:Calibri;color:black'>Kimlik
        Verileri; Sizinle iletişime geçmemizi tercih ettiğiniz taktirde sizi
        tanımlayabilmemiz ve tanıyabilmemiz için gerektiği ölçüde adınız, soyadınız, yaşınız,
        vergi veya vatandaşlık/kimlik/vergi numaranız gibi kimlik bilgilerinizdir. </span><span
        style='font-family:"Times New Roman",serif;mso-fareast-font-family:Calibri'></span></p>



    <p class=MsoNormal style='margin-bottom:0cm;text-align:justify;text-justify:
inter-ideograph;line-height:normal;background:white'><b style='mso-bidi-font-weight:
normal'><span style='font-family:"Times New Roman",serif;mso-fareast-font-family:
Calibri;color:black'>5- Kişisel Veri Toplamanın Yöntemi <span class=GramE>Ve</span>
          Hukuki Sebebi:</span></b></p>

    <p class=MsoNormal style='margin-bottom:0cm;text-align:justify;text-justify:
inter-ideograph;line-height:normal;background:white'><span style='font-family:
"Times New Roman",serif;mso-fareast-font-family:Calibri;color:black'>Kişisel
        verilerinizi yalnızca <span class=SpellE>KVKK.’da</span> belirtilen hukuki
        sebeplerden bir veya birkaçı bulunuyorsa yahut verilerinizi işleyebilmemiz için
        açık rızanızı vermiş iseniz işleyebiliriz. <span style='mso-spacerun:yes'> </span><span class=SpellE>Wep</span>
        tabanlı, <span class=SpellE>android</span> ve <span class=SpellE>app</span>
        uygulamalarımızdaki “Detaylı Bilgi İçin İletişime Geçin” “Mobil Uygulamayı
        İndirme ve Üye Olma” “Üye Olma” “Ücretsiz Demo Talepleri”, her çeşit
        “Sorgulamalar” ve “Abonelik kayıtları” için yapacağınız girişlerle ve bu
        kısımlarda yer alan “Onayla<span class=GramE>”,<span style='mso-spacerun:yes'> 
          </span>“</span>Gönder” , “Uygulama Talep Et” “Abonelik” vb. talep ve onayınızla
        kişisel verileriniz için gerekli onayı vermiş olmaktasınız.</span></p>



    <p class=MsoNormal style='margin-bottom:0cm;text-align:justify;text-justify:
inter-ideograph;line-height:normal;background:white'><span style='font-family:
"Times New Roman",serif;mso-fareast-font-family:Calibri;color:black'>Kişisel
        verileriniz Şirketimiz tarafından yukarıda sıralanan amaçlar kapsamında ve her
        türlü sözlü, yazılı ya da elektronik ortamda (şirketimize doğrudan sizin
        tarafınızdan sağlanan tüm bilgi ve belgeler, telefon veya e-posta
        yazışmalarındaki paylaşımlarınız, verdiğiniz telefon numaralarınız, iş yerimizi
        ziyaretiniz sırasında, tanıtım etkinliklerinde fiziki ortamda belge,
        sözleşmeler ve matbu formlar; elektronik ortamda ise kurumsal web sitesi, mobil
        uygulamalar, e-posta, şirket içi yazılım, görüntü ve çağrı merkezi ses kayıt
        sistemleri üzerinden) toplanacaktır. İnternet sitemiz ve mobil uygulamamız
        üzerinde “</span><span style='color:black;mso-color-alt:windowtext'><a
          href="https://nam11.safelinks.protection.outlook.com/?url=http%3A%2F%2Fcdata.e-alora.com%2Fbuy-now-5.htm&amp;data=04%7C01%7C%7Cef4b83d1b70640dcdcf808d8743c4333%7C84df9e7fe9f640afb435aaaaaaaaaaaa%7C1%7C0%7C637387149452980095%7CUnknown%7CTWFpbGZsb3d8eyJWIjoiMC4wLjAwMDAiLCJQIjoiV2luMzIiLCJBTiI6Ik1haWwiLCJXVCI6Mn0%3D%7C1000&amp;sdata=l10uFtx0wt3XPqQ3hed3NJeodG8jB%2BcnZ4JIlzaKeAk%3D&amp;reserved=0"
          target="_blank"
          title="Outlook tarafından korunuyor: http://cdata.e-alora.com/buy-now-5.htm. Bağlantıyı izlemek için tıklayın veya dokunun."><span
            style='font-family:"Times New Roman",serif;mso-fareast-font-family:Calibri;
color:black;text-decoration:none;text-underline:none'>Kişisel Verilerin
            Korunması Hakkında Aydınlatma Metnini</span></a></span><span style='font-family:
"Times New Roman",serif;mso-fareast-font-family:Calibri;color:black'>&nbsp;okudum,
        içeriğini anladım ve onaylıyorum.” bölümünü onaylayarak da açık rızayı vermiş
        olacaksınız.</span></p>



    <p class=MsoNormal style='margin-bottom:0cm;text-align:justify;text-justify:
inter-ideograph;line-height:normal;background:white'><span style='font-family:
"Times New Roman",serif;mso-fareast-font-family:Calibri;color:black'>Yukarıdaki
        yöntemler doğrultusunda topladığımız kişisel verilerinizi Açık rızanızın
        bulunması veya aşağıda yer alan hallerden en az birinin bulunması durumunda
        Açık Rıza’nızın bulunmadığı durumlarda da işlenmesi mümkün olacaktır.</span></p>



    <p class=MsoListParagraphCxSpFirst style='margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:14.2pt;mso-add-space:auto;text-align:justify;
text-justify:inter-ideograph;text-indent:-14.2pt;line-height:normal;mso-list:
l4 level1 lfo9;background:white'><span style='font-family:
Wingdings;mso-fareast-font-family:Wingdings;mso-bidi-font-family:Wingdings;
color:black'><span style='mso-list:Ignore'>v<span style='font:7.0pt "Times New Roman"'>
          </span></span></span><span dir=LTR></span><span style='font-family:
"Times New Roman",serif;mso-fareast-font-family:Calibri;color:black'>Türkiye
        Cumhuriyeti’nde yürürlükte olan kanun ve yönetmelik hükümlerinin işlemeyi
        gerekli kılması </span></p>

    <p class=MsoListParagraphCxSpMiddle style='margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:14.2pt;mso-add-space:auto;text-align:justify;
text-justify:inter-ideograph;text-indent:-14.2pt;line-height:normal;mso-list:
l4 level1 lfo9;background:white'><span style='font-family:
Wingdings;mso-fareast-font-family:Wingdings;mso-bidi-font-family:Wingdings;
color:black'><span style='mso-list:Ignore'>v<span style='font:7.0pt "Times New Roman"'>
          </span></span></span><span dir=LTR></span><span style='font-family:
"Times New Roman",serif;mso-fareast-font-family:Calibri;color:black'>Fiili
        imkânsızlık nedeniyle rızanızı açıklayamayacak durumdayken şahsınızın veya bir
        başkasının yaşamı veya vücut bütünlüğünün korunması için zorunlu olması,</span></p>

    <p class=MsoListParagraphCxSpMiddle style='margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:14.2pt;mso-add-space:auto;text-align:justify;
text-justify:inter-ideograph;text-indent:-14.2pt;line-height:normal;mso-list:
l4 level1 lfo9;background:white'><span style='font-family:
Wingdings;mso-fareast-font-family:Wingdings;mso-bidi-font-family:Wingdings;
color:black'><span style='mso-list:Ignore'>v<span style='font:7.0pt "Times New Roman"'>
          </span></span></span><span dir=LTR></span><span style='font-family:
"Times New Roman",serif;mso-fareast-font-family:Calibri;color:black'>Tarafınız
        veya hizmeti aldığınız kurum ile akdetmiş olduğumuz sözleşmenin ifası için
        gerekli olması,</span></p>

    <p class=MsoListParagraphCxSpMiddle style='margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:14.2pt;mso-add-space:auto;text-align:justify;
text-justify:inter-ideograph;text-indent:-14.2pt;line-height:normal;mso-list:
l4 level1 lfo9;background:white'><span style='font-family:
Wingdings;mso-fareast-font-family:Wingdings;mso-bidi-font-family:Wingdings;
color:black'><span style='mso-list:Ignore'>v<span style='font:7.0pt "Times New Roman"'>
          </span></span></span><span dir=LTR></span><span style='font-family:
"Times New Roman",serif;mso-fareast-font-family:Calibri;color:black'>Yasal
        yükümlülüklerimizin yerine getirilmesi amacıyla kişisel verilerinizin
        işlenmesinin gerekli olması,</span></p>

    <p class=MsoListParagraphCxSpMiddle style='margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:14.2pt;mso-add-space:auto;text-align:justify;
text-justify:inter-ideograph;text-indent:-14.2pt;line-height:normal;mso-list:
l4 level1 lfo9;background:white'><span style='font-family:
Wingdings;mso-fareast-font-family:Wingdings;mso-bidi-font-family:Wingdings;
color:black'><span style='mso-list:Ignore'>v<span style='font:7.0pt "Times New Roman"'>
          </span></span></span><span dir=LTR></span><span style='font-family:
"Times New Roman",serif;mso-fareast-font-family:Calibri;color:black'>Kişisel verinizin
        tarafınızca alenileştirilmiş olması,</span></p>

    <p class=MsoListParagraphCxSpMiddle style='margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:14.2pt;mso-add-space:auto;text-align:justify;
text-justify:inter-ideograph;text-indent:-14.2pt;line-height:normal;mso-list:
l4 level1 lfo9;background:white'><span style='font-family:
Wingdings;mso-fareast-font-family:Wingdings;mso-bidi-font-family:Wingdings;
color:black'><span style='mso-list:Ignore'>v<span style='font:7.0pt "Times New Roman"'>
          </span></span></span><span dir=LTR></span><span style='font-family:
"Times New Roman",serif;mso-fareast-font-family:Calibri;color:black'>Şirket
        olarak yasal veya <span class=SpellE>sözleşmesel</span> haklarımızın
        kullanılması veya korunması için gerekli olması,</span></p>

    <p class=MsoListParagraphCxSpLast style='margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:14.2pt;mso-add-space:auto;text-align:justify;
text-justify:inter-ideograph;text-indent:-14.2pt;line-height:normal;mso-list:
l4 level1 lfo9;background:white'><span style='font-family:
Wingdings;mso-fareast-font-family:Wingdings;mso-bidi-font-family:Wingdings;
color:black'><span style='mso-list:Ignore'>v<span style='font:7.0pt "Times New Roman"'>
          </span></span></span><span dir=LTR></span><span style='font-family:
"Times New Roman",serif;mso-fareast-font-family:Calibri;color:black'>Temel hak
        ve özgürlüklerinize zarar vermemek kaydıyla kişisel verilerinizin işlenmesinin
        meşru menfaatimiz için gerekli olması.</span></p>



    <p class=MsoNormal style='margin-bottom:0cm;text-align:justify;text-justify:
inter-ideograph;line-height:normal;background:white'><span style='font-family:
"Times New Roman",serif;mso-fareast-font-family:Calibri;color:black'>Tarafınızla
        olan ilişkilerimiz kapsamında topladığımız kişisel verilerinizi, hukuki
        yükümlülüklerimizin yerine getirilmesi, bir hakkın tesisi, kullanılması veya
        korunması ile meşru menfaatlerimiz için zorunlu olması hukuki sebeplerinden bir
        veya birkaçına dayalı olarak; keza fiziki veya elektronik ortamda, form/tutanak
        doldurulması, onay verilmesi, çağrı merkezi görüşmeleri yapılması, veri
        entegrasyonu, internet sitesi veya mobil uygulama <span class=SpellE>vb</span>
        yazılımlar üzerinden abonelik, üyelik, kullanıcı girişi veya canlı sohbet
        gerçekleştirilmesi, onay kodu gönderilmesi suretiyle ve benzeri diğer kanallar
        aracılığı ile otomatik, kısmen otomatik veya veri kayıt sisteminin parçası
        olmak kaydıyla otomatik olmayan yollar ile elde edilmekte ve&nbsp;Şirketimizin
        faaliyetlerini sürdürebilmesi ve hizmet sunabilmesi için <span class=SpellE>KVKK’nın</span>
        5. ve 6. maddelerinde belirtilen kişisel verileri işleme şartları ve amaçları
        kapsamında ve ilgili sair mevzuat tarafından öngörülen esas ve usuller
        doğrultusunda işbu Aydınlatma <span class=SpellE>Metni’nde</span> belirtilen
        amaçların sağlanması, hizmetin verilebilmesi ve hukuki yükümlülüklerimizi
        yerine getirilmesine yönelik yasal ve hukuki nedenlerle işlemekteyiz. </span></p>



    <p class=MsoNormal style='margin-bottom:0cm;text-align:justify;text-justify:
inter-ideograph;line-height:normal;background:white'><b style='mso-bidi-font-weight:
normal'><span style='font-family:"Times New Roman",serif;mso-fareast-font-family:
Calibri;color:black'>6- İşlenen Kişisel Verilerin Kimlere <span class=GramE>Ve</span>
          Hangi Amaçla Aktarılabileceği;</span></b></p>

    <p class=MsoNormal style='margin-bottom:0cm;text-align:justify;text-justify:
inter-ideograph;line-height:normal;background:white'><span style='font-family:
"Times New Roman",serif;mso-fareast-font-family:Calibri;color:black'>Kişisel
        verileriniz; &nbsp;Şirketimizden bilgi ve belge almaya yasal yetkileri bulunan Bakanlıklar,
        Kamu kurum ve kuruluşları ile bağlı sair birimler başta olmak üzere yetkili
        makamlar tarafından talep edilmesi, yetkili makamlar tarafından görevlendirilen
        kişiler tarafından talep edilmesi halinde ya da </span><span style='font-family:
"Times New Roman",serif;mso-fareast-font-family:Calibri;color:black;mso-themecolor:
text1'>tarafımıza yüklenen bildirim ve/veya raporlama yükümlülüğümüz kapsamında
        ilgili kurum ve kuruluşlar ile mevcut veya ileride kurulacak olan iş ile ilgili
        bağlı ortaklıklarımız, yazılım ve referans fiyat uygulaması sağlayıcımız ile iş
        ilişkisi içerisinde bulunduğumuz özel sigorta şirketleri, uygulamalar üzerinden
        sizinle iletişime geçmesini talep etmeniz şartıyla bu hususta sizinle iletişime
        geçecek gerçek veya tüzel 3.kişilerle (oto bayileri, araç tedarikçileri, oto galeri,
        filo şirketleri gibi), denetçiler, yasal hakların muhafazası, korunması ve
        savunulmasının gerekmesi halinde danışmanlarımız ve avukatlarımızla, hizmetin
        verilmesini gerektirdiği</span><span style='font-family:"Times New Roman",serif;
mso-fareast-font-family:Calibri;color:black'> ölçüde proje yürüttüğümüz iş
        ortakları ve bilişim teknolojileri desteği (onay kodu gönderme, teyit, sunucu, <span
          class=SpellE>hosting</span>, yazılım, bulut bilişim vb.) ve destek aldığımız
        diğer hizmet sağlayıcılarımız ile şirketimizin muhasebe, mali müşavir,
        pazarlama ve satın alma gibi ilgili birim personelleri ile 6698 sayılı Kanun’un
        8. ve 9. Maddelerinde belirtilen kişisel veri işleme şartları ve yukarda
        belirtilen amaçlar çerçevesinde paylaşılabilecektir.</span></p>



    <p class=MsoNormal style='margin-bottom:0cm;text-align:justify;text-justify:
inter-ideograph;line-height:normal;background:white'><b style='mso-bidi-font-weight:
normal'><span style='font-family:"Times New Roman",serif;mso-fareast-font-family:
Calibri;color:black'>7- Kişisel Verisi İşlenmiş Kişinin Hakları;</span></b></p>

    <p class=MsoNormal style='margin-bottom:0cm;text-align:justify;text-justify:
inter-ideograph;line-height:normal;background:white'><span style='font-family:
"Times New Roman",serif;mso-fareast-font-family:Calibri;color:black'>KVKK.’<span class=SpellE><span
            class=GramE>nın</span></span><span class=GramE> <span style='mso-spacerun:yes'> </span>11.</span> maddesi
        uyarınca kişisel verisi
        işlenen herkes, işleyen veri sorumlusuna başvurarak kendisiyle ilgili;</span></p>

    <p class=MsoNormal style='margin-bottom:0cm;text-align:justify;text-justify:
inter-ideograph;line-height:normal;background:white'><span style='font-family:
"Times New Roman",serif;mso-fareast-font-family:Calibri;color:black'>a) Kişisel
        veri işlenip işlenmediğini öğrenme,</span></p>

    <p class=MsoNormal style='margin-bottom:0cm;text-align:justify;text-justify:
inter-ideograph;line-height:normal;background:white'><span style='font-family:
"Times New Roman",serif;mso-fareast-font-family:Calibri;color:black'>b) Kişisel
        verileri işlenmişse buna ilişkin bilgi talep etme,</span></p>

    <p class=MsoNormal style='margin-bottom:0cm;text-align:justify;text-justify:
inter-ideograph;line-height:normal;background:white'><span style='font-family:
"Times New Roman",serif;mso-fareast-font-family:Calibri;color:black'>c) Kişisel
        verilerin işlenme amacını ve bunların amacına uygun kullanılıp kullanılmadığını
        öğrenme,</span></p>

    <p class=MsoNormal style='margin-bottom:0cm;text-align:justify;text-justify:
inter-ideograph;line-height:normal;background:white'><span class=GramE><span style='font-family:"Times New Roman",serif;mso-fareast-font-family:Calibri;
color:black'>ç</span></span><span style='font-family:"Times New Roman",serif;
mso-fareast-font-family:Calibri;color:black'>) Yurt içinde veya yurt dışında
        kişisel verilerin aktarıldığı üçüncü kişileri bilme,</span></p>

    <p class=MsoNormal style='margin-bottom:0cm;text-align:justify;text-justify:
inter-ideograph;line-height:normal;background:white'><span style='font-family:
"Times New Roman",serif;mso-fareast-font-family:Calibri;color:black'>d) Kişisel
        verilerin eksik veya yanlış işlenmiş olması hâlinde bunların düzeltilmesini
        isteme,</span></p>

    <p class=MsoNormal style='margin-bottom:0cm;text-align:justify;text-justify:
inter-ideograph;line-height:normal;background:white'><span style='font-family:
"Times New Roman",serif;mso-fareast-font-family:Calibri;color:black'>e) Kanunun
        7.maddesinde öngörülen şartlar çerçevesinde kişisel verilerin silinmesini veya
        yok edilmesini isteme,</span></p>

    <p class=MsoNormal style='margin-bottom:0cm;text-align:justify;text-justify:
inter-ideograph;line-height:normal;background:white'><span style='font-family:
"Times New Roman",serif;mso-fareast-font-family:Calibri;color:black'>f) (d) ve
        (e) bentleri uyarınca yapılan işlemlerin, kişisel verilerin aktarıldığı üçüncü
        kişilere bildirilmesini isteme,</span></p>

    <p class=MsoNormal style='margin-bottom:0cm;text-align:justify;text-justify:
inter-ideograph;line-height:normal;background:white'><span style='font-family:
"Times New Roman",serif;mso-fareast-font-family:Calibri;color:black'>g) İşlenen
        verilerin münhasıran otomatik sistemler vasıtasıyla analiz edilmesi suretiyle
        kişinin kendisi aleyhine bir sonucun ortaya çıkmasına itiraz etme,</span></p>

    <p class=MsoNormal style='margin-bottom:0cm;text-align:justify;text-justify:
inter-ideograph;line-height:normal;background:white'><span class=GramE><span style='font-family:"Times New Roman",serif;mso-fareast-font-family:Calibri;
color:black'>ğ</span></span><span style='font-family:"Times New Roman",serif;
mso-fareast-font-family:Calibri;color:black'>) Kişisel verilerin kanuna aykırı
        olarak işlenmesi sebebiyle zarara uğraması hâlinde zararın giderilmesini talep
        etme haklarına sahiptir.</span></p>



    <p class=MsoNormal style='margin-bottom:0cm;text-align:justify;text-justify:
inter-ideograph;line-height:normal;background:white'><span style='font-family:
"Times New Roman",serif;mso-fareast-font-family:Calibri;color:black'>Topladığımız
        ve işlediğimiz kişisel verilerinizin 6698 sayılı Kişisel Verilerin İşlenmesi
        Kanunu 4. Maddesi gereğince doğru ve gerektiğinde güncel olması gerekmektedir.
        Bu nedenle, kişisel verilerinizde herhangi bir değişiklik meydana gelmesi
        halinde, güncel ve doğru kişisel bilgilerinizi aşağıda belirtilen yöntemlerle
        bildirebilirsiniz.</span></p>



    <p class=MsoNormal style='margin-bottom:0cm;text-align:justify;text-justify:
inter-ideograph;line-height:normal;background:white'><b style='mso-bidi-font-weight:
normal'><span style='font-family:"Times New Roman",serif;mso-fareast-font-family:
Calibri;color:black'>8- Talepleriniz Hakkında Bizimle İletişime Geçmek İçin;</span></b></p>

    <p class=MsoNormal style='margin-bottom:0cm;text-align:justify;text-justify:
inter-ideograph;line-height:normal;background:white'><span style='font-family:
"Times New Roman",serif;mso-fareast-font-family:Calibri;color:black'>Kişisel
        verilerinizin düzeltilmesini ve silinmesini talep etme hakları dahil,
        verilerinizin işlenmesine ilişkin tüm haklarınız ile ilgili bilgi almak ve
        haklarınızı kullanmak için,</span></p>



    <p class=MsoNormal style='margin-bottom:0cm;text-align:justify;text-justify:
inter-ideograph;line-height:normal;background:white'><span style='font-family:
"Times New Roman",serif;mso-fareast-font-family:Calibri;color:black'>İnternet </span><span style='font-family:"Times New Roman",serif;mso-fareast-font-family:Calibri;
color:black;mso-themecolor:text1'>sitemizde yer alan “<span class=GramE>KVKK<span style='mso-spacerun:yes'> 
          </span>Başvuru</span> <span class=SpellE>Formu”nun</span>
        ıslak imzalı bir nüshasını, kimliğinizi tespit edici bir belge ile şahsen veya
        Kanunun 11.madde kapsamında sayılan haklara ilişkin başvuru yapmaya yetkili
        olduğunu gösterir ve noter tasdikli bir vekâletname ile vekaleten teslim
        edebilir ya da noter aracılığıyla şirketimizin başlangıçta belirtilen&nbsp;adresine
        gönderebilirsiniz.</span></p>



    <p class=MsoNormal style='margin-bottom:0cm;text-align:justify;text-justify:
inter-ideograph;line-height:normal;background:white'><span style='font-family:
"Times New Roman",serif;mso-fareast-font-family:Calibri;color:black'>Elektronik
        olarak talepte bulunulması halinde;</span></p>

    <p class=MsoNormal style='text-align:justify;text-justify:inter-ideograph'><span style='font-family:"Times New Roman",serif;mso-fareast-font-family:Calibri;
color:black'>“Veri Sorumlusuna Başvuru Usul ve Esasları Hakkına <span class=SpellE>Tebliğ”in</span> 5. maddesi uyarıca,
        güvenli elektronik imza,
        mobil imza ya da Şirketimize daha önce bildirdiğiniz ve sistemlerimizde kayıtlı
        bulunan elektronik posta adresini kullanmak
        suretiyle&nbsp;iletebilirsiniz.&nbsp;</span></p>

    <p class=MsoNormal style='margin-bottom:0cm;text-align:justify;text-justify:
inter-ideograph;line-height:normal;background:white'><span style='font-family:
"Times New Roman",serif;mso-fareast-font-family:Calibri;color:black'>Şirketimize
        ilettiğiniz talepleriniz, talebinizin niteliğine göre en kısa sürede ve en geç
        otuz gün içerisinde, yazılı olarak veya elektronik ortamda
        cevaplandırılacaktır. Ancak, işlemin Şirket için ayrıca bir maliyeti
        gerektirmesi hâlinde, Kişisel Verileri Koruma Kurulu tarafından&nbsp;</span><span
        style='color:black;mso-color-alt:windowtext'><a
          href="http://www.resmigazete.gov.tr/eskiler/2018/03/20180310-6.htm"><span style='font-family:"Times New Roman",serif;mso-fareast-font-family:Calibri;
color:black;text-decoration:none;text-underline:none'>Veri Sorumlusuna Başvuru
            Usul <span class=GramE>Ve</span> Esasları Hakkında Tebliğ</span></a></span><span style='font-family:"Times New Roman",serif;mso-fareast-font-family:Calibri;
color:black'>’de belirlenen tarifedeki ücret alınabilir.</span></p>



    <p class=MsoNormal style='margin-bottom:0cm;text-align:justify;text-justify:
inter-ideograph;line-height:normal;background:white'><span style='font-family:
"Times New Roman",serif;mso-fareast-font-family:Calibri;color:black'>Şirket
        tarafından talebinizin niteliğine ve başvuru yönteminize göre Şirket tarafından
        başvurunun size ait olup olmadığının belirlenmesi ve böylece haklarınızı
        koruyabilmek amacıyla ek doğrulamalar (kayıtlı telefonunuza mesaj gönderilmesi,
        aranmanız, Şirkette kayıtlı başka bir iletişim yöntemini kullanarak size
        ulaşabilir ve başvurunun size ait olup olmadığının teyidi gibi) isteyebiliriz.&nbsp;
        İşbu Aydınlatma <span class=SpellE>Metni’nde</span> belirtilen amaçlarla
        işlenmiş olan kişisel verileriniz; <span class=SpellE>KVKK’nın</span> ilgili
        hükümlerine göre işlenmesi gerektiren amaç ortadan kalktığında ve Kanunların
        belirlediği süreler geçince tarafımızca anonimleştirilerek kullanılmaya devam
        edilebilecektir.</span></p>



    <p class=MsoNormal style='margin-bottom:0cm;text-align:justify;text-justify:
inter-ideograph;line-height:normal;background:white'><span style='font-family:
"Times New Roman",serif;mso-fareast-font-family:Calibri;color:black'>CDI
        Otomotiv Bilgi Hizmetleri A.Ş. (Koşuyolu <span class=SpellE>Mh</span>. <span class=SpellE>Halili</span> <span
          class=SpellE>Sk</span>. No:9/2 34718 Kadıköy /
        İstanbul, Ticaret Sicil No: 828237, <span class=SpellE>Mersis</span> No: 0203031125400012)
        tarafından internet alanında Kullanıcılarına daha iyi hizmet vermek için kişisel
        verileri hukuka uygun olarak toplamakta, saklanmakta ve hizmetin gerektirdiği
        ölçüde paylaşılmasını sağlamakta ve gizliliğini korumaktadır. Bu amacını
        gerçekleştirebilmek için Kullanıcıların kişisel verileri, yukarıda detayları
        açıklanan kapsam ve koşullarda CDI</span><span style='font-family:"Times New Roman",serif;
mso-fareast-font-family:Calibri;color:red'> </span><span style='font-family:
"Times New Roman",serif;mso-fareast-font-family:Calibri;color:black'>tarafından
        işlenmekte hizmetin verilmesini sağlayacak ölçüde sınırlı şekilde paylaşılmaktadır.
      </span></p>





    <p class=MsoNormal style='margin-bottom:0cm;text-align:justify;text-justify:
inter-ideograph;line-height:normal;background:white'><b style='mso-bidi-font-weight:
normal'><span style='font-family:"Times New Roman",serif;mso-fareast-font-family:
Calibri;color:black;mso-themecolor:text1'>İletişim Bilgilerimiz:</span></b></p>

    <p class=MsoNormal style='margin-bottom:0cm;text-align:justify;text-justify:
inter-ideograph;line-height:normal;background:white'><span style='font-family:
"Times New Roman",serif;mso-fareast-font-family:Calibri;color:black;mso-themecolor:
text1'>Şirket adı/<span class=GramE>unvanı :CDI</span> Otomotiv Bilgi
        Hizmetleri Anonim Şirketi</span></p>

    <p class=MsoNormal style='margin-bottom:0cm;text-align:justify;text-justify:
inter-ideograph;line-height:normal;background:white'><span style='font-family:
"Times New Roman",serif;mso-fareast-font-family:Calibri;color:black;mso-themecolor:
text1'>Ticaret Sicil No: 828237</span></p>

    <p class=MsoNormal style='margin-bottom:0cm;text-align:justify;text-justify:
inter-ideograph;line-height:normal;background:white'><span class=SpellE><span style='font-family:"Times New Roman",serif;mso-fareast-font-family:Calibri;
color:black;mso-themecolor:text1'>Mersis</span></span><span style='font-family:
"Times New Roman",serif;mso-fareast-font-family:Calibri;color:black;mso-themecolor:
text1'> No: 0203031125400012</span></p>

    <p class=MsoNormal style='margin-bottom:0cm;text-align:justify;text-justify:
inter-ideograph;line-height:normal;background:white'><span style='font-family:
"Times New Roman",serif;mso-fareast-font-family:Calibri;color:black;mso-themecolor:
text1'>Adresi. Koşuyolu <span class=SpellE>Mh</span>. <span class=SpellE>Halili</span>
        <span class=SpellE>Sk</span>. No:9/2 34718 Kadıköy / İstanbul</span></p>

    <p class=MsoNormal style='margin-bottom:0cm;text-align:justify;text-justify:
inter-ideograph;line-height:normal;background:white'><span style='font-family:
"Times New Roman",serif;mso-fareast-font-family:Calibri;color:red'>KEP adresi: </span><span
        style='color:black;mso-color-alt:windowtext'><a
          href="mailto:cdiotomotiv@hs06.kep.tr">cdiotomotiv@hs06.kep.tr</a></span><span style='font-family:"Times New Roman",serif;mso-fareast-font-family:Calibri;
color:red'></span></p>



    <p class=MsoNormal align=center style='text-align:center'><b style='mso-bidi-font-weight:
normal'><span style='font-family:"Times New Roman",serif;mso-fareast-font-family:
Calibri;color:black'>VERİ SAHİBİNİN AÇIK RIZA BEYANI</span></b></p>

    <p class=MsoNormal style='text-align:justify;text-justify:inter-ideograph'><span style='font-family:"Times New Roman",serif;mso-fareast-font-family:Calibri;
color:black'>6698 sayılı “Kişisel Verilerin Korunması Kanunu” gereğince,
        kişisel verilerimin ve iletişim bilgilerimin işlenmesine, tarafımca sözlü, yazılı
        veya elektronik ortamda verilen kimliğimi ve iletişim bilgilerimi belirleyen
        veya belirlemeye yarayanlar da dahil olmak üzere her türlü kişisel verimin,
        Şirket tarafından işlenmesine, ilgili mevzuatlar kapsamında ve <span class=SpellE>aydınlama</span> metninde
        belirtildiği şekilde paylaşım gerektiren
        hallerde ve amaçlarla 3.kişilerle paylaşılmasına; kişisel veriler ve iletişim
        bilgilerinin 6698 sayılı “Kişisel Verilerin Korunması <span class=SpellE>Kanunu”nda</span>
        tanımlanan kapsamda aşağıda detayları verilen kişisel ve iletişim verilerin
        işlenmesine muvafakat ettiğimi kabul, beyan ve taahhüt ederim. Kimliği belirli
        veya belirlenebilir bir gerçek kişiye ait olduğu açık olan; kısmen veya tamamen
        otomatik şekilde veya veri kayıt sisteminin bir parçası olarak otomatik olmayan
        şekilde işlenen; kişinin kimliğine dair bilgilerin bulunduğu verilerimin; ad ve
        <span class=SpellE>soyad</span>, bilgisi; telefon numarası, adres, e-mail
        adresi, faks numarası, IP adresi gibi bilgileri, kişisel veri içeren belgelerin
        kopyası niteliğindeki belgelerde yer alan verileri Web tabanlı, <span class=SpellE>android</span> ve <span
          class=SpellE>app</span> uygulamalarınızda yöneltilmiş
        olan her türlü talep veya şikayetin alınması ve değerlendirilmesine ilişkin
        kişisel veriler, araca ait teknik bilgiler, plaka, şasi ve <span class=SpellE>tramer</span>
        bilgisi gibi bilgilerin 6698 sayılı Kişisel Verilerin Korunması Kanunu
        kapsamında, kişisel verilerimin ve iletişim bilgilerimin Şirket tarafından
        yasadaki esaslar çerçevesinde toplanmasına, kaydedilmesine, işlenmesine,
        saklanmasına ve araç <span class=SpellE>tedariği</span> yapan 3.kişilerle ve
        paydaşlar ile ticari amaçla paylaşılmasına peşinen izin verdiğimi kabul, beyan
        ve taahhüt ederim, AÇIK RIZAM VARDIR. </span></p>

    <p class=MsoNormal style='text-align:justify;text-justify:inter-ideograph'><span style='font-family:"Times New Roman",serif;mso-fareast-font-family:Calibri;
color:black'>Sayın ziyaretçimiz, Web tabanlı, <span class=SpellE>android</span>
        ve <span class=SpellE>app</span> uygulamalarınızda sistem üzerinden vereceğiniz
        ve kayıt altına alınacak olan onayınızla, iş bu Aydınlatma metnini okumuş ve
        AÇIK RIZA <span class=SpellE>BEYANI’nı</span> vermiş olacaksınız.</span></p>
  </div>
</div>
<div id="demo_contract_modal" class="modal-wrapper" style="display: none">
  <h3>Demo Kullanım Sözleşmesi</h3>
  <div class="modal-body">
  </div>
</div>
<!-- #Aggrement modal -->
